import { mix, clamp, mixColor, createPathMorph, createSvg, createMotionSvg, createMotionLine, createMotionEllipse, createMotionPath, NS, INK, PINK, easeMotion, setMotionPaint } from './helpers.js';


function renderCurtain() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const leftCircle = document.createElementNS(NS, "circle");
    leftCircle.classList.add("animatedVisualSwap__vectorShape");
    leftCircle.setAttribute("fill", "none");
    layer.appendChild(leftCircle);

    const rightCircle = document.createElementNS(NS, "circle");
    rightCircle.classList.add("animatedVisualSwap__vectorShape");
    rightCircle.setAttribute("fill", "none");
    layer.appendChild(rightCircle);

    const rightExtraCircle = document.createElementNS(NS, "circle");
    rightExtraCircle.classList.add("animatedVisualSwap__vectorShape");
    rightExtraCircle.setAttribute("fill", "none");
    layer.appendChild(rightExtraCircle);

    return {
        node: svg,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const grow = 1 - (1 - smooth) ** 1.8;
            const color = mixColor(INK, PINK, smooth);
            const groupOpacity = mix(0.25, 1, grow);
            const strokeOpacity = mix(0.5, 1, smooth);
            const emergeY = mix(6, 0, grow);

            layer.setAttribute("opacity", String(groupOpacity));
            layer.setAttribute(
                "transform",
                `translate(0 ${emergeY})`,
            );

            [leftCircle, rightCircle, rightExtraCircle].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(strokeOpacity));
            });

            leftCircle.setAttribute("cx", String(mix(104, 106, grow)));
            leftCircle.setAttribute("cy", "160");
            leftCircle.setAttribute("r", String(mix(70, 65, grow)));

            rightCircle.setAttribute("cx", "212");
            rightCircle.setAttribute("cy", "160");
            rightCircle.setAttribute("r", String(mix(70, 85, grow)));

            rightExtraCircle.setAttribute("cx", "212");
            rightExtraCircle.setAttribute("cy", "160");
            rightExtraCircle.setAttribute("r", String(mix(12, 67, grow)));
            rightExtraCircle.setAttribute("opacity", String(clamp((grow - 0.12) / 0.88, 0, 1)));
        },
    };
}

function renderTripleCircles() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makeCircle() {
        const c = document.createElementNS(NS, "circle");
        c.classList.add("animatedVisualSwap__vectorShape");
        c.setAttribute("fill", "none");
        c.setAttribute("r", "60");
        layer.appendChild(c);
        return c;
    }

    const top = makeCircle();
    const right = makeCircle();
    const left = makeCircle();

    return {
        node: svg,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const eased = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, eased);
            const opacity = mix(0.5, 1, eased);

            [top, right, left].forEach((c) => {
                c.setAttribute("stroke", color);
                c.setAttribute("stroke-width", "4");
                c.setAttribute("stroke-linecap", "round");
                c.setAttribute("stroke-linejoin", "round");
                c.setAttribute("stroke-dasharray", "1 12");
                c.setAttribute("stroke-opacity", String(opacity));
            });

            layer.setAttribute("opacity", String(opacity));

            top.setAttribute("cx", String(mix(160, 160, eased)));
            top.setAttribute("cy", String(mix(105, 125, eased)));

            right.setAttribute("cx", String(mix(225, 200, eased)));
            right.setAttribute("cy", String(mix(214, 195, eased)));

            left.setAttribute("cx", String(mix(94, 119, eased)));
            left.setAttribute("cy", String(mix(214, 195, eased)));
        },
    };
}

function renderTriangleMorph() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makePath(parent) {
        const p = document.createElementNS(NS, "path");
        p.classList.add("animatedVisualSwap__vectorShape");
        p.setAttribute("fill", "none");
        parent.appendChild(p);
        return p;
    }

    const bigTri = makePath(layer);
    const midGroup = document.createElementNS(NS, "g");
    layer.appendChild(midGroup);
    const midTri = makePath(midGroup);
    const smallGroup = document.createElementNS(NS, "g");
    layer.appendChild(smallGroup);
    const smallTri = makePath(smallGroup);

    const bigPath   = "M160 40L40 280H280L160 40Z";
    const midPath   = "M159.5 58L58 271L261 271L159.5 58Z";
    const smallPath = "M160 83.001L70 263.001L250 263.001L160 83.001Z";

    return {
        node: svg,
        speed: 0.048,
        touchSpeed: 0.042,
        leaveSpeed: 0.055,
        touchLeaveSpeed: 0.048,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const eased = t * t * t * (t * (t * 6 - 15) + 10);
            const color = mixColor(INK, PINK, eased);
            const opacity = mix(0.5, 1, eased);

            layer.setAttribute("opacity", String(opacity));

            [bigTri, midTri, smallTri].forEach((p) => {
                p.setAttribute("stroke", color);
                p.setAttribute("stroke-width", "4");
                p.setAttribute("stroke-linecap", "round");
                p.setAttribute("stroke-linejoin", "round");
                p.setAttribute("stroke-dasharray", "1 12");
                p.setAttribute("stroke-opacity", String(opacity));
            });

            bigTri.setAttribute("d", bigPath);
            midTri.setAttribute("d", midPath);
            smallTri.setAttribute("d", smallPath);

            midGroup.setAttribute("transform", `rotate(${mix(90, 0, eased)} 160 160)`);
            smallGroup.setAttribute("transform", `rotate(${mix(-90, 0, eased)} 160 160)`);
        },
    };
}

function renderDiamondSquare() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const topBox = document.createElementNS(NS, "path");
    topBox.classList.add("animatedVisualSwap__vectorShape");
    topBox.setAttribute("fill", "none");
    layer.appendChild(topBox);

    const middleShape = document.createElementNS(NS, "path");
    middleShape.classList.add("animatedVisualSwap__vectorShape");
    middleShape.setAttribute("fill", "none");
    layer.appendChild(middleShape);

    const bottomBox = document.createElementNS(NS, "path");
    bottomBox.classList.add("animatedVisualSwap__vectorShape");
    bottomBox.setAttribute("fill", "none");
    layer.appendChild(bottomBox);

    const topStartPath =
        "M130.584 49V101C130.584 103.209 132.375 105 134.584 105H186.584C188.793 105 190.584 103.209 190.584 101V49C190.584 46.7909 188.793 45 186.584 45H134.584C132.375 45 130.584 46.7909 130.584 49Z";
    const topEndPath =
        "M130.158 49V101C130.158 103.209 131.949 105 134.158 105H186.158C188.367 105 190.158 103.209 190.158 101V49C190.158 46.7909 188.367 45 186.158 45H134.158C131.949 45 130.158 46.7909 130.158 49Z";

    const bottomStartPath =
        "M130.584 221V272C130.584 274.209 132.375 276 134.584 276H186.584C188.793 276 190.584 274.209 190.584 272V221C190.584 218.791 188.793 217 186.584 217H134.584C132.375 217 130.584 218.791 130.584 221Z";
    const bottomEndPath =
        "M130.158 221V272C130.158 274.209 131.949 276 134.158 276H186.158C188.367 276 190.158 274.209 190.158 272V221C190.158 218.791 188.367 217 186.158 217H134.158C131.949 217 130.158 218.791 130.158 221Z";

    const middleEndPath =
        "M185.998 131.314H134C131.791 131.314 130 133.105 130 135.314V187.312C130 189.521 131.791 191.312 134 191.312H185.998C188.207 191.312 189.998 189.521 189.998 187.312V135.314C189.998 133.105 188.207 131.314 185.998 131.314Z";

    const topMorph = createPathMorph(topStartPath, topEndPath);
    const bottomMorph = createPathMorph(bottomStartPath, bottomEndPath);

    return {
        node: svg,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const eased = Math.pow(smooth, 1.6);
            const spin = mix(-45, 0, eased);
            const pivotX = 160;
            const pivotY = 161.313;
            const color = mixColor(INK, PINK, eased);
            const opacity = mix(0.5, 1, eased);

            layer.setAttribute("opacity", String(opacity));

            [topBox, middleShape, bottomBox].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            topBox.setAttribute("d", topMorph(eased));
            bottomBox.setAttribute("d", bottomMorph(eased));

            middleShape.setAttribute("d", middleEndPath);
            middleShape.style.transform = `rotate(${spin}deg)`;
        },
    };
}

function renderGearsPanel() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const frame = document.createElementNS(NS, "path");
    frame.classList.add("animatedVisualSwap__vectorShape");
    frame.setAttribute("fill", "none");
    layer.appendChild(frame);

    const divider = document.createElementNS(NS, "line");
    divider.classList.add("animatedVisualSwap__vectorShape");
    divider.setAttribute("fill", "none");
    layer.appendChild(divider);

    function makeGear() {
        const gear = document.createElementNS(NS, "path");
        gear.classList.add("animatedVisualSwap__vectorShape");
        gear.setAttribute("fill", "none");
        layer.appendChild(gear);
        return gear;
    }

    const topGear = makeGear();
    const middleGear = makeGear();
    const bottomGear = makeGear();

    const framePath =
        "M275 39.6064H43.7969C41.5877 39.6064 39.7969 41.3973 39.7969 43.6064V275C39.7969 277.21 41.5877 279 43.7969 279H275C277.209 279 279 277.21 279 275V43.6064C279 41.3973 277.209 39.6064 275 39.6064Z";
    const frameEndPath =
        "M275.203 40H44C41.7909 40 40 41.7909 40 44V275.394C40 277.603 41.7909 279.394 44 279.394H275.203C277.412 279.394 279.203 277.603 279.203 275.394V44C279.203 41.7909 277.412 40 275.203 40Z";

    const topGearStartPath =
        "M97.4545 72.4827C98.1876 69.237 102.812 69.237 103.546 72.4827V72.4827C104.021 74.5863 106.435 75.5863 108.258 74.4348V74.4348C111.072 72.6581 114.342 75.9283 112.565 78.7418V78.7418C111.414 80.5653 112.414 82.9793 114.517 83.4545V83.4545C117.763 84.1876 117.763 88.8124 114.517 89.5455V89.5455C112.414 90.0207 111.414 92.4347 112.565 94.2582V94.2582C114.342 97.0717 111.072 100.342 108.258 98.5652V98.5652C106.435 97.4137 104.021 98.4137 103.546 100.517V100.517C102.812 103.763 98.1876 103.763 97.4545 100.517V100.517C96.9793 98.4137 94.5653 97.4137 92.7418 98.5652V98.5652C89.9283 100.342 86.6581 97.0717 88.4348 94.2582V94.2582C89.5863 92.4347 88.5863 90.0207 86.4827 89.5455V89.5455C83.237 88.8124 83.237 84.1876 86.4827 83.4545V83.4545C88.5863 82.9793 89.5863 80.5653 88.4348 78.7418V78.7418C86.6581 75.9283 89.9283 72.6581 92.7418 74.4348V74.4348C94.5653 75.5863 96.9793 74.5863 97.4545 72.4827V72.4827Z";
    const middleGearStartPath =
        "M97.4545 145.483C98.1876 142.237 102.812 142.237 103.546 145.483V145.483C104.021 147.586 106.435 148.586 108.258 147.435V147.435C111.072 145.658 114.342 148.928 112.565 151.742V151.742C111.414 153.565 112.414 155.979 114.517 156.454V156.454C117.763 157.188 117.763 161.812 114.517 162.546V162.546C112.414 163.021 111.414 165.435 112.565 167.258V167.258C114.342 170.072 111.072 173.342 108.258 171.565V171.565C106.435 170.414 104.021 171.414 103.546 173.517V173.517C102.812 176.763 98.1876 176.763 97.4545 173.517V173.517C96.9793 171.414 94.5653 170.414 92.7418 171.565V171.565C89.9283 173.342 86.6581 170.072 88.4348 167.258V167.258C89.5863 165.435 88.5863 163.021 86.4827 162.546V162.546C83.237 161.812 83.237 157.188 86.4827 156.454V156.454C88.5863 155.979 89.5863 153.565 88.4348 151.742V151.742C86.6581 148.928 89.9283 145.658 92.7418 147.435V147.435C94.5653 148.586 96.9793 147.586 97.4545 145.483V145.483Z";
    const bottomGearStartPath =
        "M97.4545 219.483C98.1876 216.237 102.812 216.237 103.546 219.483V219.483C104.021 221.586 106.435 222.586 108.258 221.435V221.435C111.072 219.658 114.342 222.928 112.565 225.742V225.742C111.414 227.565 112.414 229.979 114.517 230.454V230.454C117.763 231.188 117.763 235.812 114.517 236.546V236.546C112.414 237.021 111.414 239.435 112.565 241.258V241.258C114.342 244.072 111.072 247.342 108.258 245.565V245.565C106.435 244.414 104.021 245.414 103.546 247.517V247.517C102.812 250.763 98.1876 250.763 97.4545 247.517V247.517C96.9793 245.414 94.5653 244.414 92.7418 245.565V245.565C89.9283 247.342 86.6581 244.072 88.4348 241.258V241.258C89.5863 239.435 88.5863 237.021 86.4827 236.546V236.546C83.237 235.812 83.237 231.188 86.4827 230.454V230.454C88.5863 229.979 89.5863 227.565 88.4348 225.742V225.742C86.6581 222.928 89.9283 219.658 92.7418 221.435V221.435C94.5653 222.586 96.9793 221.586 97.4545 219.483V219.483Z";
    const gearTopEndPath =
        "M115.517 83.4545C118.763 84.1876 118.763 88.8124 115.517 89.5455V89.5455C113.414 90.0207 112.414 92.4347 113.565 94.2582V94.2582C115.342 97.0717 112.072 100.342 109.258 98.5652V98.5652C107.435 97.4138 105.021 98.4137 104.546 100.517V100.517C103.812 103.763 99.1876 103.763 98.4545 100.517V100.517C97.9793 98.4137 95.5653 97.4138 93.7418 98.5652V98.5652C90.9283 100.342 87.6581 97.0717 89.4348 94.2582V94.2582C90.5862 92.4347 89.5863 90.0207 87.4827 89.5455V89.5455C84.237 88.8124 84.237 84.1876 87.4827 83.4545V83.4545C89.5863 82.9793 90.5863 80.5653 89.4348 78.7418V78.7418C87.6581 75.9283 90.9283 72.6581 93.7418 74.4348V74.4348C95.5653 75.5862 97.9793 74.5863 98.4545 72.4827V72.4827C99.1876 69.237 103.812 69.237 104.546 72.4827V72.4827C105.021 74.5863 107.435 75.5862 109.258 74.4348V74.4348C112.072 72.6581 115.342 75.9283 113.565 78.7418V78.7418C112.414 80.5653 113.414 82.9793 115.517 83.4545V83.4545Z";
    const gearMiddleEndPath =
        "M87.4827 163.546C84.237 162.812 84.237 158.188 87.4827 157.454V157.454C89.5863 156.979 90.5863 154.565 89.4348 152.742V152.742C87.6581 149.928 90.9283 146.658 93.7418 148.435V148.435C95.5653 149.586 97.9793 148.586 98.4545 146.483V146.483C99.1876 143.237 103.812 143.237 104.546 146.483V146.483C105.021 148.586 107.435 149.586 109.258 148.435V148.435C112.072 146.658 115.342 149.928 113.565 152.742V152.742C112.414 154.565 113.414 156.979 115.517 157.454V157.454C118.763 158.188 118.763 162.812 115.517 163.546V163.546C113.414 164.021 112.414 166.435 113.565 168.258V168.258C115.342 171.072 112.072 174.342 109.258 172.565V172.565C107.435 171.414 105.021 172.414 104.546 174.517V174.517C103.812 177.763 99.1876 177.763 98.4545 174.517V174.517C97.9793 172.414 95.5653 171.414 93.7418 172.565V172.565C90.9283 174.342 87.6581 171.072 89.4348 168.258V168.258C90.5863 166.435 89.5863 164.021 87.4827 163.546V163.546Z";
    const gearBottomEndPath =
        "M115.517 230.454C118.763 231.188 118.763 235.812 115.517 236.546V236.546C113.414 237.021 112.414 239.435 113.565 241.258V241.258C115.342 244.072 112.072 247.342 109.258 245.565V245.565C107.435 244.414 105.021 245.414 104.546 247.517V247.517C103.812 250.763 99.1876 250.763 98.4545 247.517V247.517C97.9793 245.414 95.5653 244.414 93.7418 245.565V245.565C90.9283 247.342 87.6581 244.072 89.4348 241.258V241.258C90.5862 239.435 89.5863 237.021 87.4827 236.546V236.546C84.237 235.812 84.237 231.188 87.4827 230.454V230.454C89.5863 229.979 90.5863 227.565 89.4348 225.742V225.742C87.6581 222.928 90.9283 219.658 93.7418 221.435V221.435C95.5653 222.586 97.9793 221.586 98.4545 219.483V219.483C99.1876 216.237 103.812 216.237 104.546 219.483V219.483C105.021 221.586 107.435 222.586 109.258 221.435V221.435C112.072 219.658 115.342 222.928 113.565 225.742V225.742C112.414 227.565 113.414 229.979 115.517 230.454V230.454Z";

    const frameMorph = createPathMorph(framePath, frameEndPath);
    const topGearMorph = createPathMorph(topGearStartPath, gearTopEndPath);
    const middleGearMorph = createPathMorph(middleGearStartPath, gearMiddleEndPath);
    const bottomGearMorph = createPathMorph(bottomGearStartPath, gearBottomEndPath);

    return {
        node: svg,
        speed: 0.06,
        touchSpeed: 0.05,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const base = t * t * (3 - 2 * t);
            const smooth = base * base * (3 - 2 * base);
            const turn = smooth;
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            [frame, divider, topGear, middleGear, bottomGear].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            frame.setAttribute("d", frameMorph(smooth));
            divider.setAttribute("x1", "161");
            divider.setAttribute("y1", String(mix(45, 46, smooth)));
            divider.setAttribute("x2", "161");
            divider.setAttribute("y2", String(mix(271, 272, smooth)));

            topGear.setAttribute("d", topGearMorph(smooth));
            middleGear.setAttribute("d", middleGearMorph(smooth));
            bottomGear.setAttribute("d", bottomGearMorph(smooth));

            topGear.style.transformBox = "fill-box";
            topGear.style.transformOrigin = "center";
            topGear.style.transform = `rotate(${90 * turn}deg)`;

            middleGear.style.transformBox = "fill-box";
            middleGear.style.transformOrigin = "center";
            middleGear.style.transform = `rotate(${-90 * turn}deg)`;

            bottomGear.style.transformBox = "fill-box";
            bottomGear.style.transformOrigin = "center";
            bottomGear.style.transform = `rotate(${90 * turn}deg)`;
        },
    };
}

function renderGearsPanelRight() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const frame = document.createElementNS(NS, "path");
    frame.classList.add("animatedVisualSwap__vectorShape");
    frame.setAttribute("fill", "none");
    layer.appendChild(frame);

    const divider = document.createElementNS(NS, "line");
    divider.classList.add("animatedVisualSwap__vectorShape");
    divider.setAttribute("fill", "none");
    layer.appendChild(divider);

    function makeGear() {
        const gear = document.createElementNS(NS, "path");
        gear.classList.add("animatedVisualSwap__vectorShape");
        gear.setAttribute("fill", "none");
        layer.appendChild(gear);
        return gear;
    }

    const topGear = makeGear();
    const middleGear = makeGear();
    const bottomGear = makeGear();

    const framePath =
        "M275 39.6064H43.7969C41.5877 39.6064 39.7969 41.3973 39.7969 43.6064V275C39.7969 277.21 41.5877 279 43.7969 279H275C277.209 279 279 277.21 279 275V43.6064C279 41.3973 277.209 39.6064 275 39.6064Z";
    const frameEndPath =
        "M275.203 40H44C41.7909 40 40 41.7909 40 44V275.394C40 277.603 41.7909 279.394 44 279.394H275.203C277.412 279.394 279.203 277.603 279.203 275.394V44C279.203 41.7909 277.412 40 275.203 40Z";

    const topGearStartPath =
        "M216.454 72.4827C217.188 69.237 221.812 69.237 222.546 72.4827V72.4827C223.021 74.5863 225.435 75.5863 227.258 74.4348V74.4348C230.072 72.6581 233.342 75.9283 231.565 78.7418V78.7418C230.414 80.5653 231.414 82.9793 233.517 83.4545V83.4545C236.763 84.1876 236.763 88.8124 233.517 89.5455V89.5455C231.414 90.0207 230.414 92.4347 231.565 94.2582V94.2582C233.342 97.0717 230.072 100.342 227.258 98.5652V98.5652C225.435 97.4137 223.021 98.4137 222.546 100.517V100.517C221.812 103.763 217.188 103.763 216.454 100.517V100.517C215.979 98.4137 213.565 97.4137 211.742 98.5652V98.5652C208.928 100.342 205.658 97.0717 207.435 94.2582V94.2582C208.586 92.4347 207.586 90.0207 205.483 89.5455V89.5455C202.237 88.8124 202.237 84.1876 205.483 83.4545V83.4545C207.586 82.9793 208.586 80.5653 207.435 78.7418V78.7418C205.658 75.9283 208.928 72.6581 211.742 74.4348V74.4348C213.565 75.5863 215.979 74.5863 216.454 72.4827V72.4827Z";
    const middleGearStartPath =
        "M216.454 145.483C217.188 142.237 221.812 142.237 222.546 145.483V145.483C223.021 147.586 225.435 148.586 227.258 147.435V147.435C230.072 145.658 233.342 148.928 231.565 151.742V151.742C230.414 153.565 231.414 155.979 233.517 156.454V156.454C236.763 157.188 236.763 161.812 233.517 162.546V162.546C231.414 163.021 230.414 165.435 231.565 167.258V167.258C233.342 170.072 230.072 173.342 227.258 171.565V171.565C225.435 170.414 223.021 171.414 222.546 173.517V173.517C221.812 176.763 217.188 176.763 216.454 173.517V173.517C215.979 171.414 213.565 170.414 211.742 171.565V171.565C208.928 173.342 205.658 170.072 207.435 167.258V167.258C208.586 165.435 207.586 163.021 205.483 162.546V162.546C202.237 161.812 202.237 157.188 205.483 156.454V156.454C207.586 155.979 208.586 153.565 207.435 151.742V151.742C205.658 148.928 208.928 145.658 211.742 147.435V147.435C213.565 148.586 215.979 147.586 216.454 145.483V145.483Z";
    const bottomGearStartPath =
        "M216.454 219.483C217.188 216.237 221.812 216.237 222.546 219.483V219.483C223.021 221.586 225.435 222.586 227.258 221.435V221.435C230.072 219.658 233.342 222.928 231.565 225.742V225.742C230.414 227.565 231.414 229.979 233.517 230.454V230.454C236.763 231.188 236.763 235.812 233.517 236.546V236.546C231.414 237.021 230.414 239.435 231.565 241.258V241.258C233.342 244.072 230.072 247.342 227.258 245.565V245.565C225.435 244.414 223.021 245.414 222.546 247.517V247.517C221.812 250.763 217.188 250.763 216.454 247.517V247.517C215.979 245.414 213.565 244.414 211.742 245.565V245.565C208.928 247.342 205.658 244.072 207.435 241.258V241.258C208.586 239.435 207.586 237.021 205.483 236.546V236.546C202.237 235.812 202.237 231.188 205.483 230.454V230.454C207.586 229.979 208.586 227.565 207.435 225.742V225.742C205.658 222.928 208.928 219.658 211.742 221.435V221.435C213.565 222.586 215.979 221.586 216.454 219.483V219.483Z";
    const gearTopEndPath =
        "M232.517 83.4545C235.763 84.1876 235.763 88.8124 232.517 89.5455V89.5455C230.414 90.0207 229.414 92.4347 230.565 94.2582V94.2582C232.342 97.0717 229.072 100.342 226.258 98.5652V98.5652C224.435 97.4138 222.021 98.4137 221.546 100.517V100.517C220.812 103.763 216.188 103.763 215.454 100.517V100.517C214.979 98.4137 212.565 97.4138 210.742 98.5652V98.5652C207.928 100.342 204.658 97.0717 206.435 94.2582V94.2582C207.586 92.4347 206.586 90.0207 204.483 89.5455V89.5455C201.237 88.8124 201.237 84.1876 204.483 83.4545V83.4545C206.586 82.9793 207.586 80.5653 206.435 78.7418V78.7418C204.658 75.9283 207.928 72.6581 210.742 74.4348V74.4348C212.565 75.5862 214.979 74.5863 215.454 72.4827V72.4827C216.188 69.237 220.812 69.237 221.546 72.4827V72.4827C222.021 74.5863 224.435 75.5862 226.258 74.4348V74.4348C229.072 72.6581 232.342 75.9283 230.565 78.7418V78.7418C229.414 80.5653 230.414 82.9793 232.517 83.4545V83.4545Z";
    const gearMiddleEndPath =
        "M204.483 163.546C201.237 162.812 201.237 158.188 204.483 157.454V157.454C206.586 156.979 207.586 154.565 206.435 152.742V152.742C204.658 149.928 207.928 146.658 210.742 148.435V148.435C212.565 149.586 214.979 148.586 215.454 146.483V146.483C216.188 143.237 220.812 143.237 221.546 146.483V146.483C222.021 148.586 224.435 149.586 226.258 148.435V148.435C229.072 146.658 232.342 149.928 230.565 152.742V152.742C229.414 154.565 230.414 156.979 232.517 157.454V157.454C235.763 158.188 235.763 162.812 232.517 163.546V163.546C230.414 164.021 229.414 166.435 230.565 168.258V168.258C232.342 171.072 229.072 174.342 226.258 172.565V172.565C224.435 171.414 222.021 172.414 221.546 174.517V174.517C220.812 177.763 216.188 177.763 215.454 174.517V174.517C214.979 172.414 212.565 171.414 210.742 172.565V172.565C207.928 174.342 204.658 171.072 206.435 168.258V168.258C207.586 166.435 206.586 164.021 204.483 163.546V163.546Z";
    const gearBottomEndPath =
        "M232.517 230.454C235.763 231.188 235.763 235.812 232.517 236.546V236.546C230.414 237.021 229.414 239.435 230.565 241.258V241.258C232.342 244.072 229.072 247.342 226.258 245.565V245.565C224.435 244.414 222.021 245.414 221.546 247.517V247.517C220.812 250.763 216.188 250.763 215.454 247.517V247.517C214.979 245.414 212.565 244.414 210.742 245.565V245.565C207.928 247.342 204.658 244.072 206.435 241.258V241.258C207.586 239.435 206.586 237.021 204.483 236.546V236.546C201.237 235.812 201.237 231.188 204.483 230.454V230.454C206.586 229.979 207.586 227.565 206.435 225.742V225.742C204.658 222.928 207.928 219.658 210.742 221.435V221.435C212.565 222.586 214.979 221.586 215.454 219.483V219.483C216.188 216.237 220.812 216.237 221.546 219.483V219.483C222.021 221.586 224.435 222.586 226.258 221.435V221.435C229.072 219.658 232.342 222.928 230.565 225.742V225.742C229.414 227.565 230.414 229.979 232.517 230.454V230.454Z";

    const frameMorph = createPathMorph(framePath, frameEndPath);
    const topGearMorph = createPathMorph(topGearStartPath, gearTopEndPath);
    const middleGearMorph = createPathMorph(middleGearStartPath, gearMiddleEndPath);
    const bottomGearMorph = createPathMorph(bottomGearStartPath, gearBottomEndPath);

    return {
        node: svg,
        speed: 0.05,
        touchSpeed: 0.04,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const base = t * t * (3 - 2 * t);
            const smooth = base * base * (3 - 2 * base);
            const turn = smooth;
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            [frame, divider, topGear, middleGear, bottomGear].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            frame.setAttribute("d", frameMorph(smooth));
            divider.setAttribute("x1", "161");
            divider.setAttribute("y1", String(mix(45, 46, smooth)));
            divider.setAttribute("x2", "161");
            divider.setAttribute("y2", String(mix(271, 272, smooth)));

            topGear.setAttribute("d", topGearMorph(smooth));
            middleGear.setAttribute("d", middleGearMorph(smooth));
            bottomGear.setAttribute("d", bottomGearMorph(smooth));

            topGear.style.transformBox = "fill-box";
            topGear.style.transformOrigin = "center";
            topGear.style.transform = `rotate(${90 * turn}deg)`;

            middleGear.style.transformBox = "fill-box";
            middleGear.style.transformOrigin = "center";
            middleGear.style.transform = `rotate(${-90 * turn}deg)`;

            bottomGear.style.transformBox = "fill-box";
            bottomGear.style.transformOrigin = "center";
            bottomGear.style.transform = `rotate(${90 * turn}deg)`;
        },
    };
}

function renderCircleRails() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makeCircle() {
        const circle = document.createElementNS(NS, "circle");
        circle.classList.add("animatedVisualSwap__vectorShape");
        circle.setAttribute("fill", "none");
        layer.appendChild(circle);
        return circle;
    }

    function makeLine() {
        const line = document.createElementNS(NS, "line");
        line.classList.add("animatedVisualSwap__vectorShape");
        line.setAttribute("fill", "none");
        layer.appendChild(line);
        return line;
    }

    const outerCircle = makeCircle();
    const innerCircle = makeCircle();
    const lineA = makeLine();
    const lineB = makeLine();
    const lineC = makeLine();

    const lines = [
        {
            node: lineA,
            xStart: 112,
            y1Start: 76,
            y2Start: 242,
            xEnd: 192,
            y1End: 68,
            y2End: 251,
        },
        {
            node: lineB,
            xStart: 122,
            y1Start: 72,
            y2Start: 248,
            xEnd: 202,
            y1End: 72,
            y2End: 248,
        },
        {
            node: lineC,
            xStart: 132,
            y1Start: 68,
            y2Start: 251,
            xEnd: 212,
            y1End: 78,
            y2End: 242,
        },
    ];

    return {
        node: svg,
        speed: 0.09,
        touchSpeed: 0.08,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t;
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            [outerCircle, innerCircle, ...lines.map((item) => item.node)].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            outerCircle.setAttribute("cx", "160");
            outerCircle.setAttribute("cy", "160");
            outerCircle.setAttribute("r", "120");

            innerCircle.setAttribute("cx", "160");
            innerCircle.setAttribute("cy", "160");
            innerCircle.setAttribute("r", "102.857");

            lines.forEach((item) => {
                item.node.setAttribute("x1", String(mix(item.xStart, item.xEnd, smooth)));
                item.node.setAttribute("x2", String(mix(item.xStart, item.xEnd, smooth)));
                item.node.setAttribute("y1", String(mix(item.y1Start, item.y1End, smooth)));
                item.node.setAttribute("y2", String(mix(item.y2Start, item.y2End, smooth)));
            });
        },
    };
}

function renderOrbitQuads() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makePath() {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        layer.appendChild(path);
        return path;
    }

    const p1 = makePath();
    const p2 = makePath();
    const p3 = makePath();
    const p4 = makePath();

    const p1Start =
        "M102.5 264C134.256 264 160 238.256 160 206.5C160 174.744 134.256 149 102.5 149C70.7436 149 45 174.744 45 206.5C45 238.256 70.7436 264 102.5 264Z";
    const p2Start =
        "M217.5 264C249.256 264 275 238.256 275 206.5C275 174.744 249.256 149 217.5 149C185.744 149 160 174.744 160 206.5C160 238.256 185.744 264 217.5 264Z";
    const p3Start =
        "M159.5 164C191.256 164 217 138.256 217 106.5C217 74.7436 191.256 49 159.5 49C127.744 49 102 74.7436 102 106.5C102 138.256 127.744 164 159.5 164Z";
    const p4Start =
        "M160 206C178.225 206 193 191.225 193 173C193 154.775 178.225 140 160 140C141.775 140 127 154.775 127 173C127 191.225 141.775 206 160 206Z";

    const p1End =
        "M210.445 238.889C226.324 211.387 216.901 176.221 189.399 160.343C161.897 144.464 126.731 153.887 110.853 181.389C94.9744 208.891 104.397 244.057 131.899 259.936C159.401 275.814 194.567 266.391 210.445 238.889Z";
    const p2End =
        "M267.945 139.296C283.824 111.794 274.401 76.628 246.899 60.7498C219.397 44.8717 184.231 54.2945 168.353 81.7963C152.474 109.298 161.897 144.465 189.399 160.343C216.901 176.221 252.067 166.798 267.945 139.296Z";
    const p3End =
        "M152.343 139.526C168.221 112.024 158.798 76.8575 131.296 60.9793C103.795 45.1012 68.6282 54.524 52.75 82.0258C36.8718 109.528 46.2946 144.694 73.7965 160.572C101.298 176.45 136.465 167.028 152.343 139.526Z";
    const p4End =
        "M188.966 160.093C198.078 144.309 192.671 124.127 176.887 115.014C161.103 105.901 140.921 111.309 131.808 127.093C122.695 142.877 128.103 163.059 143.887 172.172C159.671 181.285 179.853 175.877 188.966 160.093Z";

    const morph1 = createPathMorph(p1Start, p1End);
    const morph2 = createPathMorph(p2Start, p2End);
    const morph3 = createPathMorph(p3Start, p3End);
    const morph4 = createPathMorph(p4Start, p4End);

    return {
        node: svg,
        speed: 0.06,
        touchSpeed: 0.05,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const color = mixColor(INK, PINK, smooth);
            const groupOpacity = mix(0.5, 1, smooth);
            const strokeOpacity = mix(0.5, 1, smooth);
            const centerFill = mixColor("#F1F3F2", "#E7EAE8", smooth);

            layer.setAttribute("opacity", String(groupOpacity));

            [p1, p2, p3].forEach((el) => {
                el.setAttribute("fill", "none");
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(strokeOpacity));
            });

            p4.setAttribute("fill", centerFill);
            p4.setAttribute("stroke", color);
            p4.setAttribute("stroke-width", "4");
            p4.setAttribute("stroke-linecap", "round");
            p4.setAttribute("stroke-linejoin", "round");
            p4.setAttribute("stroke-dasharray", "1 12");
            p4.setAttribute("stroke-opacity", String(strokeOpacity));

            p1.setAttribute("d", morph1(smooth));
            p2.setAttribute("d", morph2(smooth));
            p3.setAttribute("d", morph3(smooth));
            p4.setAttribute("d", morph4(smooth));
        },
    };
}

function renderFrameRailsUp() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const outerFrame = document.createElementNS(NS, "path");
    outerFrame.classList.add("animatedVisualSwap__vectorShape");
    outerFrame.setAttribute("fill", "none");
    layer.appendChild(outerFrame);

    const innerFrame = document.createElementNS(NS, "path");
    innerFrame.classList.add("animatedVisualSwap__vectorShape");
    innerFrame.setAttribute("fill", "none");
    layer.appendChild(innerFrame);

    function makeLine() {
        const line = document.createElementNS(NS, "line");
        line.classList.add("animatedVisualSwap__vectorShape");
        line.setAttribute("fill", "none");
        layer.appendChild(line);
        return line;
    }

    const l1 = makeLine();
    const l2 = makeLine();
    const l3 = makeLine();

    const outerPath =
        "M276 40.6064H44.7969C42.5877 40.6064 40.7969 42.3973 40.7969 44.6064V276C40.7969 278.21 42.5877 280 44.7969 280H276C278.209 280 280 278.21 280 276V44.6064C280 42.3973 278.209 40.6064 276 40.6064Z";
    const innerPath =
        "M261 55H59C56.7909 55 55 56.7909 55 59V261C55 263.209 56.7909 265 59 265H261C263.209 265 265 263.209 265 261V59C265 56.7909 263.209 55 261 55Z";

    const lines = [
        { node: l1, yStart: 206, yEnd: 97 },
        { node: l2, yStart: 216, yEnd: 107 },
        { node: l3, yStart: 226, yEnd: 117 },
    ];

    return {
        node: svg,
        speed: 0.07,
        touchSpeed: 0.06,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const innerSpin = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            [outerFrame, innerFrame, ...lines.map((item) => item.node)].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            outerFrame.setAttribute("d", outerPath);
            innerFrame.setAttribute("d", innerPath);

            lines.forEach((item) => {
                const y = mix(item.yStart, item.yEnd, smooth);
                item.node.setAttribute("x1", "258");
                item.node.setAttribute("x2", "62");
                item.node.setAttribute("y1", String(y));
                item.node.setAttribute("y2", String(y));
            });
        },
    };
}

function renderFrameRailsSpread() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const outerFrame = document.createElementNS(NS, "path");
    outerFrame.classList.add("animatedVisualSwap__vectorShape");
    outerFrame.setAttribute("fill", "none");
    layer.appendChild(outerFrame);

    const innerFrame = document.createElementNS(NS, "path");
    innerFrame.classList.add("animatedVisualSwap__vectorShape");
    innerFrame.setAttribute("fill", "none");
    layer.appendChild(innerFrame);

    function makeLine() {
        const line = document.createElementNS(NS, "line");
        line.classList.add("animatedVisualSwap__vectorShape");
        line.setAttribute("fill", "none");
        layer.appendChild(line);
        return line;
    }

    const l1 = makeLine();
    const l2 = makeLine();
    const l3 = makeLine();

    const outerPath =
        "M276 40.6064H44.7969C42.5877 40.6064 40.7969 42.3973 40.7969 44.6064V276C40.7969 278.21 42.5877 280 44.7969 280H276C278.209 280 280 278.21 280 276V44.6064C280 42.3973 278.209 40.6064 276 40.6064Z";
    const innerPath =
        "M261 55H59C56.7909 55 55 56.7909 55 59V261C55 263.209 56.7909 265 59 265H261C263.209 265 265 263.209 265 261V59C265 56.7909 263.209 55 261 55Z";

    const lines = [
        { node: l1, yStart: 150, yEnd: 100 },
        { node: l2, yStart: 160, yEnd: 160 },
        { node: l3, yStart: 170, yEnd: 220 },
    ];

    return {
        node: svg,
        speed: 0.07,
        touchSpeed: 0.06,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const innerSpin = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            [outerFrame, innerFrame, ...lines.map((item) => item.node)].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            outerFrame.setAttribute("d", outerPath);
            innerFrame.setAttribute("d", innerPath);

            lines.forEach((item) => {
                const y = mix(item.yStart, item.yEnd, smooth);
                item.node.setAttribute("x1", "258");
                item.node.setAttribute("x2", "62");
                item.node.setAttribute("y1", String(y));
                item.node.setAttribute("y2", String(y));
            });
        },
    };
}

function renderDiamondHatch() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makePath() {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        layer.appendChild(path);
        return path;
    }

    function makeLine() {
        const line = document.createElementNS(NS, "line");
        line.classList.add("animatedVisualSwap__vectorShape");
        line.setAttribute("fill", "none");
        layer.appendChild(line);
        return line;
    }

    const leftPath = makePath();
    const rightPath = makePath();

    // Start: rect corners converted to diamond paths (same M-C-L-C-L-C-L-C-L-Z structure as end paths)
    // Left rect matrix(0.707107 0.707106 -0.707107 0.707106 119.33 61) w=140.234 h=140.473
    // Corners: top=(119.33,61) right=(218.456,160.125) bottom=(119.161,259.419) left=(20.035,160.294)
    const leftStart = "M119.33 61C119.33 61 119.33 61 119.33 61L218.456 160.125C218.456 160.125 218.456 160.125 218.456 160.125L119.161 259.419C119.161 259.419 119.161 259.419 119.161 259.419L20.035 160.294C20.035 160.294 20.035 160.294 20.035 160.294L119.33 61Z";
    // Right rect matrix(0.707107 0.707106 -0.707107 0.707106 200.688 61.0229) w=140.442 h=140.203
    // Corners: top=(200.688,61.0229) right=(299.96,160.29) bottom=(200.857,259.397) left=(101.585,160.125)
    const rightStart = "M200.688 61.0229C200.688 61.0229 200.688 61.0229 200.688 61.0229L299.96 160.29C299.96 160.29 299.96 160.29 299.96 160.29L200.857 259.397C200.857 259.397 200.857 259.397 200.857 259.397L101.585 160.125C101.585 160.125 101.585 160.125 101.585 160.125L200.688 61.0229Z";

    const leftEnd = "M116.634 63.6959C118.143 62.1865 120.572 62.1283 122.152 63.5635L225.231 157.2C226.978 158.787 226.978 161.534 225.231 163.121L121.983 256.926C120.403 258.362 117.974 258.304 116.464 256.794L22.8282 163.158C21.2661 161.596 21.2661 159.063 22.8282 157.501L116.634 63.6959Z";
    const rightEnd = "M197.865 63.5859C199.445 62.1507 201.874 62.209 203.383 63.7183L297.167 157.501C298.729 159.064 298.729 161.596 297.167 163.158L203.552 256.772C202.043 258.282 199.614 258.34 198.034 256.905L94.8076 163.122C93.0605 161.535 93.0607 158.788 94.8079 157.201L197.865 63.5859Z";

    const morphLeft = createPathMorph(leftStart, leftEnd);
    const morphRight = createPathMorph(rightStart, rightEnd);

    // Lines expand from start coords to end coords
    const lines = [
        { node: makeLine(), x1s: 152.101, x2s: 169.778, y1s: 116.782, y2s: 116.782, x1e: 149, x2e: 173, y1e: 117, y2e: 117 },
        { node: makeLine(), x1s: 145.186, x2s: 175.96, y1s: 126.867, y2s: 126.867, x1e: 140, x2e: 181, y1e: 127, y2e: 127 },
        { node: makeLine(), x1s: 133.129, x2s: 185.129, y1s: 137.556, y2s: 137.556, x1e: 126, x2e: 193, y1e: 138, y2e: 138 },
        { node: makeLine(), x1s: 124.091, x2s: 196.865, y1s: 148.395, y2s: 148.395, x1e: 113, x2e: 206, y1e: 148, y2e: 148 },
        { node: makeLine(), x1s: 113.23, x2s: 207.682, y1s: 158.33, y2s: 158.33, x1e: 102, x2e: 218, y1e: 158, y2e: 158 },
        { node: makeLine(), x1s: 119.565, x2s: 201.371, y1s: 169.168, y2s: 169.168, x1e: 111, x2e: 208, y1e: 169, y2e: 169 },
        { node: makeLine(), x1s: 129.497, x2s: 190.529, y1s: 180.007, y2s: 180.007, x1e: 121, x2e: 200, y1e: 180, y2e: 180 },
        { node: makeLine(), x1s: 141.235, x2s: 180.59, y1s: 189.943, y2s: 189.943, x1e: 132, x2e: 188, y1e: 190, y2e: 190 },
        { node: makeLine(), x1s: 152.069, x2s: 170.65, y1s: 200.781, y2s: 200.781, x1e: 146, x2e: 173, y1e: 201, y2e: 201 },
    ];

    return {
        node: svg,
        speed: 0.06,
        touchSpeed: 0.05,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const color = mixColor(INK, PINK, smooth);
            const groupOpacity = mix(0.5, 1, smooth);
            const strokeOpacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(groupOpacity));

            [leftPath, rightPath, ...lines.map((item) => item.node)].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(strokeOpacity));
            });

            leftPath.setAttribute("d", morphLeft(smooth));
            rightPath.setAttribute("d", morphRight(smooth));

            lines.forEach((item) => {
                item.node.setAttribute("x1", String(mix(item.x1s, item.x1e, smooth)));
                item.node.setAttribute("x2", String(mix(item.x2s, item.x2e, smooth)));
                item.node.setAttribute("y1", String(mix(item.y1s, item.y1e, smooth)));
                item.node.setAttribute("y2", String(mix(item.y2s, item.y2e, smooth)));
            });
        },
    };
}

function renderShelfAnalysis() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const leftRect = document.createElementNS(NS, "path");
    leftRect.classList.add("animatedVisualSwap__vectorShape");
    leftRect.setAttribute("fill", "none");
    layer.appendChild(leftRect);

    const centerShape = document.createElementNS(NS, "path");
    centerShape.classList.add("animatedVisualSwap__vectorShape");
    centerShape.setAttribute("fill", "none");
    layer.appendChild(centerShape);

    const rightRect = document.createElementNS(NS, "path");
    rightRect.classList.add("animatedVisualSwap__vectorShape");
    rightRect.setAttribute("fill", "none");
    layer.appendChild(rightRect);

    const topLine = document.createElementNS(NS, "line");
    topLine.classList.add("animatedVisualSwap__vectorShape");
    topLine.setAttribute("fill", "none");
    layer.appendChild(topLine);

    const bottomLine = document.createElementNS(NS, "line");
    bottomLine.classList.add("animatedVisualSwap__vectorShape");
    bottomLine.setAttribute("fill", "none");
    layer.appendChild(bottomLine);

    const leftRectPath =
        "M88.7691 124.47L27.6836 124.47C25.4745 124.47 23.6836 126.261 23.6836 128.47L23.6836 190.726C23.6836 192.935 25.4745 194.726 27.6836 194.726L88.7691 194.726C90.9782 194.726 92.7691 192.935 92.7691 190.726L92.7691 128.47C92.7691 126.261 90.9782 124.47 88.7691 124.47Z";
    const rightRectPath =
        "M290.171 124.47L227.915 124.47C225.705 124.47 223.915 126.261 223.915 128.47L223.915 190.726C223.915 192.935 225.705 194.726 227.915 194.726L290.171 194.726C292.38 194.726 294.171 192.935 294.171 190.726L294.171 128.47C294.171 126.261 292.38 124.47 290.171 124.47Z";

    const centerStartPath =
        "M204.823 156.584L160.803 112.564C159.241 111.002 156.708 111.002 155.146 112.564L111.126 156.584C109.564 158.146 109.564 160.678 111.126 162.24L155.147 206.261C156.709 207.823 159.241 207.823 160.803 206.261L204.823 162.241C206.385 160.679 206.385 158.146 204.823 156.584Z";
    const centerEndPath =
        "M193.102 190.539L193.102 128.285C193.102 126.076 191.311 124.285 189.102 124.285L126.849 124.285C124.64 124.285 122.849 126.076 122.849 128.285L122.849 190.539C122.849 192.748 124.64 194.539 126.849 194.539L189.102 194.539C191.311 194.539 193.102 192.748 193.102 190.539Z";

    const centerMorph = createPathMorph(centerStartPath, centerEndPath);

    return {
        node: svg,
        speed: 0.07,
        touchSpeed: 0.06,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const innerSpin = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            [leftRect, centerShape, rightRect, topLine, bottomLine].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            leftRect.setAttribute("d", leftRectPath);
            rightRect.setAttribute("d", rightRectPath);
            centerShape.setAttribute("d", centerMorph(smooth));

            topLine.setAttribute("x1", "298.026");
            topLine.setAttribute("y1", "93");
            topLine.setAttribute("x2", "21.0002");
            topLine.setAttribute("y2", "93");

            bottomLine.setAttribute("x1", "298.026");
            bottomLine.setAttribute("y1", "230");
            bottomLine.setAttribute("x2", "21.0002");
            bottomLine.setAttribute("y2", "230");
        },
    };
}

function renderPackageAnalysis() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makePath() {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        layer.appendChild(path);
        return path;
    }

    function makeLine() {
        const line = document.createElementNS(NS, "line");
        line.classList.add("animatedVisualSwap__vectorShape");
        line.setAttribute("fill", "none");
        layer.appendChild(line);
        return line;
    }

    const leftRect = makePath();
    const centerShape = makePath();
    const rightRect = makePath();
    const l1 = makeLine();
    const l2 = makeLine();
    const l3 = makeLine();
    const l4 = makeLine();

    const leftRectPath =
        "M88.7691 124.47L27.6836 124.47C25.4745 124.47 23.6836 126.261 23.6836 128.47L23.6836 190.726C23.6836 192.935 25.4745 194.726 27.6836 194.726L88.7691 194.726C90.9782 194.726 92.7691 192.935 92.7691 190.726L92.7691 128.47C92.7691 126.261 90.9782 124.47 88.7691 124.47Z";
    const rightRectPath =
        "M290.171 124.47L227.915 124.47C225.705 124.47 223.915 126.261 223.915 128.47L223.915 190.726C223.915 192.935 225.705 194.726 227.915 194.726L290.171 194.726C292.38 194.726 294.171 192.935 294.171 190.726L294.171 128.47C294.171 126.261 292.38 124.47 290.171 124.47Z";

    const centerStartPath =
        "M193.101 190.539L193.101 128.285C193.101 126.076 191.31 124.285 189.101 124.285L126.848 124.285C124.639 124.285 122.848 126.076 122.848 128.285L122.848 190.539C122.848 192.748 124.639 194.539 126.848 194.539L189.101 194.539C191.31 194.539 193.101 192.748 193.101 190.539Z";
    const centerEndPath =
        "M197.133 133.538L137 117.426C134.867 116.854 132.673 118.12 132.101 120.254L115.989 180.386C115.417 182.52 116.684 184.714 118.817 185.285L178.95 201.398C181.084 201.97 183.277 200.703 183.849 198.569L199.961 138.437C200.533 136.303 199.267 134.11 197.133 133.538Z";

    const centerMorph = createPathMorph(centerStartPath, centerEndPath);
    const lines = [
        { node: l1, start: [185, 140, 130, 140], end: [146.219, 128.284, 131.984, 181.41] },
        { node: l2, start: [185, 153, 130, 153], end: [158.777, 131.649, 144.541, 184.775] },
        { node: l3, start: [185, 165, 130, 165], end: [170.367, 134.754, 156.132, 187.88] },
        { node: l4, start: [185, 178, 130, 178], end: [182.924, 138.119, 168.689, 191.245] },
    ];

    return {
        node: svg,
        speed: 0.07,
        touchSpeed: 0.06,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const innerSpin = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            [leftRect, centerShape, rightRect, ...lines.map((item) => item.node)].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            leftRect.setAttribute("d", leftRectPath);
            centerShape.setAttribute("d", centerMorph(smooth));
            rightRect.setAttribute("d", rightRectPath);

            lines.forEach((item) => {
                item.node.setAttribute("x1", String(mix(item.start[0], item.end[0], smooth)));
                item.node.setAttribute("y1", String(mix(item.start[1], item.end[1], smooth)));
                item.node.setAttribute("x2", String(mix(item.start[2], item.end[2], smooth)));
                item.node.setAttribute("y2", String(mix(item.start[3], item.end[3], smooth)));
            });
        },
    };
}

function renderRetailAuditInPieteleTinta() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makePath() {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        layer.appendChild(path);
        return path;
    }

    function makeLine() {
        const line = document.createElementNS(NS, "line");
        line.classList.add("animatedVisualSwap__vectorShape");
        line.setAttribute("fill", "none");
        layer.appendChild(line);
        return line;
    }

    const leftRect = makePath();
    const centerShape = makePath();
    const rightRect = makePath();
    const l1 = makeLine();
    const l2 = makeLine();
    const l3 = makeLine();
    const l4 = makeLine();
    const l5 = makeLine();

    const leftRectPath =
        "M88.7691 124.47L27.6836 124.47C25.4745 124.47 23.6836 126.261 23.6836 128.47L23.6836 190.726C23.6836 192.935 25.4745 194.726 27.6836 194.726L88.7691 194.726C90.9782 194.726 92.7691 192.935 92.7691 190.726L92.7691 128.47C92.7691 126.261 90.9782 124.47 88.7691 124.47Z";
    const rightRectPath =
        "M290.171 124.47L227.915 124.47C225.705 124.47 223.915 126.261 223.915 128.47L223.915 190.726C223.915 192.935 225.705 194.726 227.915 194.726L290.171 194.726C292.38 194.726 294.171 192.935 294.171 190.726L294.171 128.47C294.171 126.261 292.38 124.47 290.171 124.47Z";

    const centerStartPath =
        "M204.823 156.584L160.803 112.564C159.241 111.002 156.708 111.002 155.146 112.564L111.126 156.584C109.564 158.146 109.564 160.678 111.126 162.24L155.147 206.261C156.709 207.823 159.241 207.823 160.803 206.261L204.823 162.241C206.385 160.679 206.385 158.146 204.823 156.584Z";
    const centerEndPath =
        "M193.102 190.539L193.102 128.285C193.102 126.076 191.311 124.285 189.102 124.285L126.849 124.285C124.64 124.285 122.849 126.076 122.849 128.285L122.849 190.539C122.849 192.748 124.64 194.539 126.849 194.539L189.102 194.539C191.311 194.539 193.102 192.748 193.102 190.539Z";

    const centerMorph = createPathMorph(centerStartPath, centerEndPath);
    const lines = [
        { node: l1, start: [159.719, 120.828, 120.828, 159.719], end: [185.708, 135, 130.708, 135] },
        { node: l2, start: [168.911, 130.021, 130.02, 168.912], end: [185.708, 148, 130.708, 148] },
        { node: l3, start: [177.396, 138.506, 138.506, 177.397], end: [185.708, 160, 130.708, 160] },
        { node: l4, start: [186.589, 147.699, 147.698, 186.589], end: [185.708, 173, 130.708, 173] },
        { node: l5, start: [193.589, 155.699, 154.698, 194.589], end: [185, 183.605, 130, 183.605] },
    ];

    return {
        node: svg,
        speed: 0.07,
        touchSpeed: 0.06,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            [leftRect, centerShape, rightRect, ...lines.map((item) => item.node)].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            leftRect.setAttribute("d", leftRectPath);
            centerShape.setAttribute("d", centerMorph(smooth));
            rightRect.setAttribute("d", rightRectPath);

            lines.forEach((item) => {
                item.node.setAttribute("x1", String(mix(item.start[0], item.end[0], smooth)));
                item.node.setAttribute("y1", String(mix(item.start[1], item.end[1], smooth)));
                item.node.setAttribute("x2", String(mix(item.start[2], item.end[2], smooth)));
                item.node.setAttribute("y2", String(mix(item.start[3], item.end[3], smooth)));
            });
        },
    };
}

function renderStrategiaDeExport() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makeCircle() {
        const circle = document.createElementNS(NS, "circle");
        circle.classList.add("animatedVisualSwap__vectorShape");
        circle.setAttribute("fill", "none");
        layer.appendChild(circle);
        return circle;
    }

    const c1 = makeCircle();
    const c2 = makeCircle();

    const start = {
        c1: { cx: 88, cy: 216, r: 55 },
        c2: { cx: 217, cy: 119, r: 70 },
    };
    const end = {
        c1: { cx: 103, cy: 201, r: 70 },
        c2: { cx: 199.5, cy: 136.5, r: 87.5 },
    };

    const circles = [
        [c1, start.c1, end.c1],
        [c2, start.c2, end.c2],
    ];

    return {
        node: svg,
        speed: 0.07,
        touchSpeed: 0.06,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            circles.forEach(([node, from, to]) => {
                node.setAttribute("stroke", color);
                node.setAttribute("stroke-width", "4");
                node.setAttribute("stroke-linecap", "round");
                node.setAttribute("stroke-linejoin", "round");
                node.setAttribute("stroke-dasharray", "1 12");
                node.setAttribute("stroke-opacity", String(opacity));
                node.setAttribute("cx", String(mix(from.cx, to.cx, smooth)));
                node.setAttribute("cy", String(mix(from.cy, to.cy, smooth)));
                node.setAttribute("r", String(mix(from.r, to.r, smooth)));
            });
        },
    };
}

function renderWebsiteAnalysis() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makePath() {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        layer.appendChild(path);
        return path;
    }

    function makeLine() {
        const line = document.createElementNS(NS, "line");
        line.classList.add("animatedVisualSwap__vectorShape");
        line.setAttribute("fill", "none");
        layer.appendChild(line);
        return line;
    }

    const outerFrame = makePath();
    const topPanel = makePath();
    const bottomPanel = makePath();
    const line1 = makeLine();
    const line2 = makeLine();
    const line3 = makeLine();
    const line4 = makeLine();
    const line5 = makeLine();
    const line6 = makeLine();
    const line7 = makeLine();
    const line8 = makeLine();
    const line9 = makeLine();
    const line10 = makeLine();
    const line11 = makeLine();
    const line12 = makeLine();
    const line13 = makeLine();

    const outerPath =
        "M276 40.6064H44.7969C42.5877 40.6064 40.7969 42.3973 40.7969 44.6064V276C40.7969 278.21 42.5877 280 44.7969 280H276C278.209 280 280 278.21 280 276V44.6064C280 42.3973 278.209 40.6064 276 40.6064Z";
    const topStartPath =
        "M261 55H59C56.7909 55 55 56.7909 55 59V102C55 104.209 56.7909 106 59 106H261C263.209 106 265 104.209 265 102V59C265 56.7909 263.209 55 261 55Z";
    const topEndPath =
        "M261 55H59C56.7909 55 55 56.7909 55 59V156C55 158.209 56.7909 160 59 160H261C263.209 160 265 158.209 265 156V59C265 56.7909 263.209 55 261 55Z";
    const bottomStartPath =
        "M261 119H59C56.7909 119 55 120.791 55 123V262C55 264.209 56.7909 266 59 266H261C263.209 266 265 264.209 265 262V123C265 120.791 263.209 119 261 119Z";
    const bottomEndPath =
        "M261 171H59C56.7909 171 55 172.791 55 175V262C55 264.209 56.7909 266 59 266H261C263.209 266 265 264.209 265 262V175C265 172.791 263.209 171 261 171Z";

    const topMorph = createPathMorph(topStartPath, topEndPath);
    const bottomMorph = createPathMorph(bottomStartPath, bottomEndPath);
    const lines = [
        { node: line1, yStart: 132, yEnd: 182 },
        { node: line2, yStart: 142, yEnd: 192 },
        { node: line3, yStart: 152, yEnd: 202 },
        { node: line4, yStart: 162, yEnd: 212 },
        { node: line5, yStart: 172, yEnd: 222 },
        { node: line6, yStart: 182, yEnd: 232 },
        { node: line7, yStart: 192, yEnd: 242 },
        { node: line8, yStart: 202, yEnd: 252 },
        { node: line9, yStart: 212, yEnd: 252 },
        { node: line10, yStart: 222, yEnd: 252, fadeOutOnHover: true },
        { node: line11, yStart: 232, yEnd: 252, fadeOutOnHover: true },
        { node: line12, yStart: 242, yEnd: 252, fadeOutOnHover: true },
        { node: line13, yStart: 252, yEnd: 252, fadeOutOnHover: true },
    ];

    return {
        node: svg,
        speed: 0.07,
        touchSpeed: 0.06,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const innerSpin = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            [outerFrame, topPanel, bottomPanel, ...lines.map((item) => item.node)].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            outerFrame.setAttribute("d", outerPath);
            topPanel.setAttribute("d", topMorph(smooth));
            bottomPanel.setAttribute("d", bottomMorph(smooth));

            lines.forEach((item) => {
                const y = mix(item.yStart, item.yEnd, smooth);
                const lineOpacity = item.fadeOutOnHover ? opacity * (1 - smooth) : opacity;

                item.node.setAttribute("stroke-opacity", String(lineOpacity));
                item.node.setAttribute("x1", "258");
                item.node.setAttribute("y1", String(y));
                item.node.setAttribute("x2", "59");
                item.node.setAttribute("y2", String(y));
            });
        },
    };
}

function renderBannerAnalysis() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const leftGroup = document.createElementNS(NS, "g");
    const rightGroup = document.createElementNS(NS, "g");
    layer.appendChild(leftGroup);
    layer.appendChild(rightGroup);

    function makePath(parent = layer) {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        parent.appendChild(path);
        return path;
    }

    const outerFrame = makePath();
    const centerShape = makePath();
    const leftShape = makePath(leftGroup);
    const rightShape = makePath(rightGroup);

    const outerPath =
        "M296.143 98H23C20.7909 98 19 99.7909 19 102V217C19 219.209 20.7909 221 23 221H296.143C298.352 221 300.143 219.209 300.143 217V102C300.143 99.7909 298.352 98 296.143 98Z";
    const centerCirclePath =
        "M160 142C169.941 142 178 150.059 178 160C178 169.941 169.941 178 160 178C150.059 178 142 169.941 142 160C142 150.059 150.059 142 160 142Z";
    const centerCircumference = 2 * Math.PI * 18;
    const leftStartPath =
        "M72.9858 117.942L33.0848 157.843C31.5227 159.406 31.5227 161.938 33.0848 163.5L72.9858 203.401C74.5479 204.963 77.0806 204.963 78.6426 203.401L118.544 163.5C120.106 161.938 120.106 159.406 118.544 157.843L78.6427 117.942C77.0806 116.38 74.5479 116.38 72.9858 117.942Z";
    const leftEndPath =
        "M104.029 128.457H47.6001C45.391 128.457 43.6001 130.248 43.6001 132.457V188.886C43.6001 191.095 45.391 192.886 47.6001 192.886H104.029C106.238 192.886 108.029 191.095 108.029 188.886V132.457C108.029 130.248 106.238 128.457 104.029 128.457Z";
    const rightStartPath =
        "M284.887 157.844L244.986 117.943C243.424 116.381 240.891 116.381 239.329 117.943L199.428 157.844C197.866 159.406 197.866 161.938 199.428 163.501L239.329 203.402C240.891 204.964 243.424 204.964 244.986 203.402L284.887 163.501C286.449 161.938 286.449 159.406 284.887 157.844Z";
    const rightEndPath =
        "M270.371 128.457H213.943C211.734 128.457 209.943 130.248 209.943 132.457V188.886C209.943 191.095 211.734 192.886 213.943 192.886H270.371C272.581 192.886 274.371 191.095 274.371 188.886V132.457C274.371 130.248 272.581 128.457 270.371 128.457Z";

    const leftCenterX = (33.0848 + 118.544) / 2;
    const leftCenterY = (117.942 + 203.401) / 2;
    const rightCenterX = (199.428 + 286.449) / 2;
    const rightCenterY = (117.943 + 203.402) / 2;

    return {
        node: svg,
        speed: 0.065,
        touchSpeed: 0.055,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const squareProgress = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            [outerFrame, centerShape, leftShape, rightShape].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            outerFrame.setAttribute("d", outerPath);
            centerShape.setAttribute("d", centerCirclePath);
            centerShape.setAttribute("stroke-dasharray", "1 8");
            centerShape.setAttribute("stroke-dashoffset", String(centerCircumference * 0.25 * smooth));
            leftShape.setAttribute("d", leftStartPath);
            rightShape.setAttribute("d", rightStartPath);
            leftGroup.setAttribute("transform", `rotate(${mix(0, 45, squareProgress)} ${leftCenterX} ${leftCenterY})`);
            rightGroup.setAttribute("transform", `rotate(${mix(0, -45, squareProgress)} ${rightCenterX} ${rightCenterY})`);
        },
    };
}

function renderVideoSpotAnalysis() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const spotGroup = document.createElementNS(NS, "g");
    layer.appendChild(spotGroup);

    function makePath(parent = layer) {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        parent.appendChild(path);
        return path;
    }

    const frame = makePath();
    const spot = makePath(spotGroup);

    const framePath =
        "M296 79H23C20.7909 79 19 80.7909 19 83V237C19 239.209 20.7909 241 23 241H296C298.209 241 300 239.209 300 237V83C300 80.7909 298.209 79 296 79Z";
    const spotPath =
        "M37.5 0L-37.5 37.5L-37.5 -37.5L37.5 0Z";
    const spotCenterX = 165.5;
    const spotCenterY = 159.5;

    return {
        node: svg,
        speed: 0.07,
        touchSpeed: 0.06,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const innerSpin = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, smooth);
            const opacity = mix(0.5, 1, smooth);

            layer.setAttribute("opacity", String(opacity));

            [frame, spot].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            frame.setAttribute("d", framePath);
            spot.setAttribute("d", spotPath);
            spotGroup.setAttribute(
                "transform",
                `translate(${spotCenterX} ${spotCenterY}) rotate(${mix(0, -180, smooth)})`,
            );
        },
    };
}

function renderConfusionAnalysis() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makePath() {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        layer.appendChild(path);
        return path;
    }

    function makeLine() {
        const line = document.createElementNS(NS, "line");
        line.classList.add("animatedVisualSwap__vectorShape");
        line.setAttribute("fill", "none");
        layer.appendChild(line);
        return line;
    }

    const leftShape = makePath();
    const rightShape = makePath();
    const l1 = makeLine();
    const l2 = makeLine();
    const l3 = makeLine();
    const l4 = makeLine();
    const l5 = makeLine();

    const leftStartPath =
        "M211 160L41 75L41 245L211 160Z";
    const leftEndPath =
        "M221 160L51 75L51 245L221 160Z";
    const rightStartPath =
        "M108 160L278 245L278 75L108 160Z";
    const rightEndPath =
        "M98 160L268 245L268 75L98 160Z";

    const leftMorph = createPathMorph(leftStartPath, leftEndPath);
    const rightMorph = createPathMorph(rightStartPath, rightEndPath);
    const lines = [
        { node: l1, start: [173.5, 147.5, 144.5, 147.5], end: [183, 148, 135, 148] },
        { node: l2, start: [166.5, 176.5, 151.5, 176.5], end: [179, 177, 141, 177] },
        { node: l3, start: [191.5, 155.5, 127.5, 155.5], end: [201, 156, 117, 156] },
        { node: l4, start: [182.5, 169.5, 137.5, 169.5], end: [192, 169, 128, 169] },
        { node: l5, start: [195.5, 162.5, 123.5, 162.5], end: [205, 163, 115, 163] },
    ];

    return {
        node: svg,
        speed: 0.055,
        touchSpeed: 0.045,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const flow = smooth * smooth * (3 - 2 * smooth);
            const squareSpin = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, flow);
            const opacity = mix(0.5, 1, flow);

            layer.setAttribute("opacity", String(opacity));

            [leftShape, rightShape, ...lines.map((item) => item.node)].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            leftShape.setAttribute("d", leftMorph(smooth));
            rightShape.setAttribute("d", rightMorph(smooth));

            lines.forEach((item) => {
                item.node.setAttribute("x1", String(mix(item.start[0], item.end[0], smooth)));
                item.node.setAttribute("y1", String(mix(item.start[1], item.end[1], smooth)));
                item.node.setAttribute("x2", String(mix(item.start[2], item.end[2], smooth)));
                item.node.setAttribute("y2", String(mix(item.start[3], item.end[3], smooth)));
            });
        },
    };
}

function renderMarketingStrategyElaboration() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    const middleGroup = document.createElementNS(NS, "g");
    const innerGroup = document.createElementNS(NS, "g");
    svg.appendChild(layer);
    layer.appendChild(middleGroup);
    layer.appendChild(innerGroup);

    function makePath(parent = layer) {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        parent.appendChild(path);
        return path;
    }

    const outerFrame = makePath();
    const middleShape = makePath(middleGroup);
    const innerShape = makePath(innerGroup);
    const circleShape = makePath();

    const outerPath =
        "M276 40.6064H44.7969C42.5877 40.6064 40.7969 42.3973 40.7969 44.6064V276C40.7969 278.21 42.5877 280 44.7969 280H276C278.209 280 280 278.21 280 276V44.6064C280 42.3973 278.209 40.6064 276 40.6064Z";
    const middleStartPath =
        "M97.4443 43.8038L41.2351 216.935C40.553 219.036 41.703 221.293 43.8037 221.976L216.667 278.188C218.767 278.871 221.023 277.721 221.705 275.62L277.915 102.489C278.597 100.388 277.447 98.1311 275.346 97.448L102.483 41.2364C100.382 40.5533 98.1264 41.7028 97.4443 43.8038Z";
    const middleEndPath =
        "M250.633 64.8262L68.6057 64.8262C66.3967 64.8262 64.6051 66.6169 64.6041 68.8259L64.519 250.599C64.5179 252.808 66.3078 254.598 68.5168 254.598H250.544C252.753 254.598 254.545 252.808 254.546 250.599L254.631 68.8259C254.632 66.6169 252.842 64.8262 250.633 64.8262Z";
    const innerStartPath =
        "M141.349 58.1889L57.4691 173.727C56.1713 175.515 56.5676 178.017 58.3543 179.316L173.798 263.262C175.585 264.561 178.085 264.165 179.383 262.377L263.264 146.839C264.561 145.052 264.165 142.549 262.378 141.25L146.935 57.3044C145.148 56.0052 142.647 56.4012 141.349 58.1889Z";
    const innerEndPath =
        "M231.812 84.9141L89.0356 84.9141C86.8265 84.9141 85.0343 86.7049 85.0326 88.914L84.9244 231.652C84.9228 233.861 86.7123 235.652 88.9214 235.652L231.697 235.652C233.906 235.652 235.699 233.861 235.7 231.652L235.808 88.914C235.81 86.7049 234.021 84.9141 231.812 84.9141Z";
    const circleStartPath =
        "M160 219.999C193.137 219.999 220 193.136 220 159.999C220 126.862 193.137 99.999 160 99.999C126.863 99.999 100 126.862 100 159.999C100 193.136 126.863 219.999 160 219.999Z";
    const circleEndPath =
        "M161 220.999C194.137 220.999 221 194.136 221 160.999C221 127.862 194.137 100.999 161 100.999C127.863 100.999 101 127.862 101 160.999C101 194.136 127.863 220.999 161 220.999Z";

    const innerMorph = createPathMorph(innerStartPath, innerEndPath);
    const circleMorph = createPathMorph(circleStartPath, circleEndPath);

    return {
        node: svg,
        speed: 0.062,
        touchSpeed: 0.054,
        leaveSpeed: 0.03,
        touchLeaveSpeed: 0.025,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const flow = t * t * t * (t * (t * 6 - 15) + 10);
            const rotateFlow = t * t * (3 - 2 * t);
            const color = mixColor(INK, PINK, flow);
            const opacity = mix(0.5, 1, flow);

            layer.setAttribute("opacity", String(opacity));

            [outerFrame, middleShape, innerShape, circleShape].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            outerFrame.setAttribute("d", outerPath);
            middleShape.setAttribute("d", middleStartPath);
            innerShape.setAttribute("d", innerMorph(flow));
            middleGroup.setAttribute("transform", `rotate(${72 * rotateFlow} 160 160)`);
            innerGroup.removeAttribute("transform");
            circleShape.setAttribute("d", circleMorph(flow));
        },
    };
}

function renderCommunicationMessageTesting() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makePath() {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        layer.appendChild(path);
        return path;
    }

    function makeLine() {
        const line = document.createElementNS(NS, "line");
        line.classList.add("animatedVisualSwap__vectorShape");
        line.setAttribute("fill", "none");
        layer.appendChild(line);
        return line;
    }

    const leftCircle = makePath();
    const rightCircle = makePath();
    const lineTop = makeLine();
    const lineBottom = makeLine();

    const leftStartPath =
        "M94 160L94 159C94 139.67 78.33 124 59 124C39.67 124 24 139.67 24 159L24 160C24 179.33 39.67 195 59 195C78.33 195 94 179.33 94 160Z";
    const leftEndPath =
        "M95 160L95 159C95 139.67 79.33 124 60 124C40.67 124 25 139.67 25 159L25 160C25 179.33 40.67 195 60 195C79.33 195 95 179.33 95 160Z";
    const rightStartPath =
        "M223 160C223 179.33 238.67 195 258 195C277.33 195 293 179.33 293 160C293 140.67 277.33 125 258 125C238.67 125 223 140.67 223 160Z";
    const rightEndPath =
        "M224 160C224 179.33 239.67 195 259 195C278.33 195 294 179.33 294 160C294 140.67 278.33 125 259 125C239.67 125 224 140.67 224 160Z";

    const leftMorph = createPathMorph(leftStartPath, leftEndPath);
    const rightMorph = createPathMorph(rightStartPath, rightEndPath);

    return {
        node: svg,
        speed: 0.055,
        touchSpeed: 0.045,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const flow = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, flow);
            const opacity = mix(0.5, 1, flow);

            layer.setAttribute("opacity", String(opacity));
            layer.removeAttribute("transform");

            [leftCircle, rightCircle, lineTop, lineBottom].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            leftCircle.setAttribute("d", leftMorph(flow));
            rightCircle.setAttribute("d", rightMorph(flow));

            const halfLen = 56.5;
            const topCx = mix(161, 165, flow);
            const topCy = mix(159.5, 164, flow);
            const topAngle = mix(-Math.PI / 2, 0, flow);
            const topDx = Math.cos(topAngle) * halfLen;
            const topDy = Math.sin(topAngle) * halfLen;

            lineTop.setAttribute("x1", String(topCx - topDx));
            lineTop.setAttribute("y1", String(topCy - topDy));
            lineTop.setAttribute("x2", String(topCx + topDx));
            lineTop.setAttribute("y2", String(topCy + topDy));
            lineTop.setAttribute("stroke-dasharray", "1 12");

            const bottomCx = mix(148, 165, flow);
            const bottomCy = mix(159.5, 151, flow);
            const bottomAngle = mix(-Math.PI / 2, 0, flow);
            const bottomDx = Math.cos(bottomAngle) * halfLen;
            const bottomDy = Math.sin(bottomAngle) * halfLen;

            lineBottom.setAttribute("x1", String(bottomCx - bottomDx));
            lineBottom.setAttribute("y1", String(bottomCy - bottomDy));
            lineBottom.setAttribute("x2", String(bottomCx + bottomDx));
            lineBottom.setAttribute("y2", String(bottomCy + bottomDy));
            lineBottom.setAttribute("stroke-dasharray", "1 12");
        },
    };
}

function renderCampaignImpactEvaluation() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makeEllipse() {
        const ellipse = document.createElementNS(NS, "ellipse");
        ellipse.classList.add("animatedVisualSwap__vectorShape");
        ellipse.setAttribute("fill", "none");
        layer.appendChild(ellipse);
        return ellipse;
    }

    const e1 = makeEllipse();
    const e2 = makeEllipse();
    const e3 = makeEllipse();

    const start = {
        e1: { cx: 159.5, cy: 160.083, rx: 110.5, ry: 92.0833 },
        e2: { cx: 159.5, cy: 160.083, rx: 61.6958, ry: 92.0833 },
        e3: { cx: 159.04, cy: 160.083, rx: 25.3229, ry: 92.0833 },
    };
    const end = {
        e1: { cx: 160, cy: 160, rx: 125, ry: 100 },
        e2: { cx: 160, cy: 160, rx: 69.7917, ry: 100 },
        e3: { cx: 159.479, cy: 160, rx: 28.6458, ry: 100 },
    };
    const scaleOriginX = 160;
    const scaleOriginY = 160;

    return {
        node: svg,
        speed: 0.055,
        touchSpeed: 0.045,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const flow = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, flow);
            const opacity = mix(0.5, 1, flow);
            const scale = mix(0.9, 1, flow);
            const tx = scaleOriginX - scaleOriginX * scale;
            const ty = scaleOriginY - scaleOriginY * scale;

            layer.setAttribute("opacity", String(opacity));
            layer.setAttribute("transform", `translate(${tx} ${ty}) scale(${scale})`);

            [e1, e2, e3].forEach((el) => {
                el.setAttribute("stroke", color);
                el.setAttribute("stroke-width", "4");
                el.setAttribute("stroke-linecap", "round");
                el.setAttribute("stroke-linejoin", "round");
                el.setAttribute("stroke-dasharray", "1 12");
                el.setAttribute("stroke-opacity", String(opacity));
            });

            e1.setAttribute("cx", String(end.e1.cx));
            e1.setAttribute("cy", String(end.e1.cy));
            e1.setAttribute("rx", String(end.e1.rx));
            e1.setAttribute("ry", String(end.e1.ry));

            e2.setAttribute("cx", String(end.e2.cx));
            e2.setAttribute("cy", String(end.e2.cy));
            e2.setAttribute("rx", String(end.e2.rx));
            e2.setAttribute("ry", String(end.e2.ry));

            e3.setAttribute("cx", String(end.e3.cx));
            e3.setAttribute("cy", String(end.e3.cy));
            e3.setAttribute("rx", String(end.e3.rx));
            e3.setAttribute("ry", String(end.e3.ry));
        },
    };
}

function renderCommunicationCampaignImpactEvaluation() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    const shape = document.createElementNS(NS, "path");
    shape.classList.add("animatedVisualSwap__vectorShape");
    shape.setAttribute("fill", "none");
    layer.appendChild(shape);

    const startPath =
        "M117.493 161.841C117.494 161.841 117.493 161.841 117.493 161.841ZM117.493 161.841C120.989 189.943 135.902 214.678 157.648 231.642C159.032 232.722 160.968 232.722 162.352 231.642C179.876 217.971 192.963 199.254 199.213 177.796C200.15 174.578 200.934 171.299 201.555 167.967C201.745 166.948 201.92 165.924 202.08 164.896C202.358 163.1 201.333 161.363 199.627 160.734C188.598 156.668 176.719 154.25 164.316 153.793C162.885 153.74 161.446 153.713 160 153.713C144.939 153.713 130.581 156.605 117.493 161.841ZM160.001 239.186C178.956 252.285 202.213 260 227.346 260C243.307 260 258.511 256.889 272.337 251.263C273.935 250.613 274.901 248.978 274.697 247.265C270.121 208.813 245.076 176.336 210.29 160.139C208.726 159.411 207.768 157.792 207.879 156.071C208.029 153.763 208.104 151.437 208.104 149.093C208.104 112.951 190.109 80.8472 162.256 60.5989C160.91 59.6207 159.09 59.6207 157.745 60.5989C129.892 80.8472 111.896 112.951 111.896 149.093C111.896 151.437 111.972 153.763 112.121 156.071C112.232 157.792 111.274 159.411 109.71 160.139C74.9239 176.336 49.8787 208.813 45.3029 247.265C45.0991 248.978 46.065 250.613 47.6627 251.263C61.4891 256.889 76.6934 260 92.6542 260C117.787 260 141.046 252.285 160.001 239.186ZM160.001 239.186C160 239.186 160.001 239.186 160.001 239.186ZM160 149.092C146.712 149.092 133.949 151.249 122.069 155.217C119.527 156.066 116.805 154.347 116.738 151.668C116.717 150.812 116.706 149.954 116.706 149.093C116.706 115.775 132.661 86.0365 157.648 66.5427C159.032 65.4632 160.968 65.4632 162.352 66.5427C187.339 86.0365 203.294 115.775 203.294 149.093C203.294 149.954 203.283 150.812 203.262 151.668C203.196 154.347 200.473 156.066 197.932 155.217C186.051 151.249 173.288 149.092 160 149.092ZM227.346 255.379C241.318 255.379 254.675 252.893 266.973 248.36C268.679 247.731 269.704 245.993 269.425 244.197C264.167 210.302 242.247 181.632 211.925 166.122C209.545 164.905 206.732 166.457 206.234 169.084C201.45 194.332 187.768 216.598 168.423 232.776C166.316 234.539 166.412 237.861 168.767 239.276C185.755 249.481 205.834 255.379 227.346 255.379ZM92.6542 255.379C114.166 255.379 134.245 249.481 151.233 239.276C153.588 237.861 153.685 234.539 151.577 232.776C132.232 216.598 118.55 194.331 113.766 169.083C113.269 166.457 110.455 164.905 108.075 166.122C77.753 181.632 55.8325 210.302 50.5745 244.197C50.2959 245.993 51.3214 247.731 53.0269 248.36C65.3246 252.893 78.6824 255.379 92.6542 255.379Z";
    const endPath =
        "M114.221 162.492C114.221 162.492 114.221 162.492 114.221 162.492ZM114.221 162.492C117.953 192.478 133.9 218.862 157.148 236.927C158.533 238.004 160.467 238.003 161.853 236.927C180.597 222.362 194.595 202.388 201.271 179.479C202.269 176.054 203.103 172.563 203.765 169.014C203.98 167.865 204.176 166.71 204.354 165.549C204.63 163.751 203.604 162.015 201.899 161.383C190.098 157.013 177.379 154.413 164.098 153.924C162.573 153.867 161.04 153.839 159.5 153.839C143.457 153.839 128.162 156.917 114.221 162.492ZM159.501 244.84C179.692 258.786 204.466 267 231.238 267C248.306 267 264.563 263.661 279.337 257.627C280.935 256.974 281.9 255.339 281.699 253.626C276.876 212.544 250.099 177.845 212.9 160.602C211.334 159.876 210.376 158.256 210.49 156.535C210.657 154.017 210.742 151.478 210.742 148.92C210.742 110.377 191.509 76.1477 161.756 54.5959C160.41 53.6205 158.591 53.6205 157.244 54.5959C127.491 76.1477 108.259 110.377 108.259 148.92C108.259 151.478 108.343 154.017 108.51 156.535C108.624 158.256 107.666 159.876 106.101 160.602C68.9013 177.845 42.124 212.544 37.3008 253.626C37.0996 255.339 38.0655 256.974 39.6626 257.627C54.4371 263.661 70.6935 267 87.7621 267C114.534 267 139.309 258.786 159.501 244.84ZM159.501 244.84C159.501 244.84 159.501 244.84 159.501 244.84ZM159.5 148.919C145.221 148.919 131.511 151.256 118.761 155.552C116.223 156.408 113.501 154.688 113.426 152.01C113.397 150.984 113.383 149.954 113.383 148.92C113.383 113.379 130.443 81.6643 157.147 60.9118C158.533 59.8353 160.468 59.8353 161.853 60.9118C188.558 81.6643 205.617 113.379 205.617 148.92C205.617 149.954 205.603 150.984 205.574 152.011C205.5 154.688 202.777 156.408 200.239 155.552C187.489 151.256 173.779 148.919 159.5 148.919ZM231.238 262.08C246.192 262.08 260.486 259.408 273.637 254.537C275.342 253.906 276.368 252.168 276.092 250.371C270.528 214.082 247.019 183.397 214.5 166.892C212.116 165.682 209.303 167.234 208.813 169.862C203.754 197.004 189.035 220.931 168.194 238.247C166.081 240.003 166.177 243.327 168.529 244.749C186.69 255.728 208.192 262.08 231.238 262.08ZM87.7621 262.08C110.808 262.08 132.31 255.728 150.471 244.748C152.823 243.327 152.919 240.003 150.806 238.247C129.965 220.931 115.246 197.004 110.187 169.862C109.697 167.234 106.884 165.682 104.501 166.892C71.981 183.397 48.4723 214.082 42.9078 250.371C42.6322 252.168 43.6577 253.906 45.3627 254.537C58.5141 259.408 72.808 262.08 87.7621 262.08Z";
    const morph = createPathMorph(startPath, endPath);

    return {
        node: svg,
        speed: 0.055,
        touchSpeed: 0.045,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const flow = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, flow);
            const opacity = mix(0.5, 1, flow);

            layer.setAttribute("opacity", String(opacity));
            layer.removeAttribute("transform");

            shape.setAttribute("stroke", color);
            shape.setAttribute("stroke-width", "4");
            shape.setAttribute("stroke-linecap", "round");
            shape.setAttribute("stroke-linejoin", "round");
            shape.setAttribute("stroke-dasharray", "1 12");
            shape.setAttribute("stroke-opacity", String(opacity));
            shape.setAttribute("d", morph(flow));
        },
    };
}

function renderPublicProgramImpactEvaluation() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makePath() {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        layer.appendChild(path);
        return path;
    }

    const p1 = makePath();
    const p2 = makePath();
    const p3 = makePath();
    const p4 = makePath();

    const startPaths = [
        "M160.418 279.964C158.578 281.187 156.121 280.522 155.016 278.609L136.313 246.214C119.621 217.303 128.497 180.648 155.925 162.43C157.765 161.208 160.223 161.872 161.327 163.785L180.031 196.181C196.722 225.091 187.846 261.746 160.418 279.964Z",
        "M158.656 39.1088C160.497 37.8865 162.954 38.5509 164.059 40.4641L182.762 72.8597C199.453 101.77 190.577 138.425 163.15 156.643C161.309 157.866 158.852 157.201 157.747 155.288L139.044 122.892C122.353 93.9823 131.229 57.3269 158.656 39.1088Z",
        "M39.1088 160.418C37.8865 158.578 38.5509 156.12 40.4641 155.016L72.8597 136.312C101.77 119.621 138.425 128.497 156.643 155.925C157.866 157.765 157.201 160.222 155.288 161.327L122.892 180.03C93.9823 196.722 57.3269 187.846 39.1088 160.418Z",
        "M279.966 158.658C281.188 160.499 280.524 162.956 278.611 164.061L246.215 182.764C217.305 199.455 180.65 190.579 162.431 163.152C161.209 161.311 161.874 158.854 163.787 157.749L196.182 139.046C225.092 122.355 261.748 131.231 279.966 158.658Z",
    ];
    const endPaths = [
        "M245.316 244.07C244.879 246.235 242.672 247.503 240.538 246.932L204.405 237.25C172.16 228.61 152.517 196.414 159.029 164.138C159.466 161.972 161.674 160.704 163.808 161.276L199.94 170.958C232.185 179.598 251.828 211.793 245.316 244.07Z",
        "M73.7598 75.0043C74.1967 72.8388 76.4042 71.5709 78.538 72.1427L114.671 81.8244C146.916 90.4644 166.559 122.66 160.046 154.937C159.609 157.102 157.402 158.37 155.268 157.798L119.135 148.116C86.8905 139.476 67.2476 107.281 73.7598 75.0043Z",
        "M75.0053 245.316C72.8398 244.879 71.5719 242.672 72.1437 240.538L81.8254 204.405C90.4654 172.16 122.661 152.517 154.938 159.029C157.103 159.466 158.371 161.674 157.799 163.808L148.117 199.94C139.477 232.185 107.282 251.828 75.0053 245.316Z",
        "M244.073 73.7603C246.238 74.1972 247.506 76.4046 246.934 78.5385L237.253 114.671C228.613 146.916 196.417 166.559 164.141 160.047C161.975 159.61 160.707 157.402 161.279 155.269L170.961 119.136C179.601 86.891 211.796 67.248 244.073 73.7603Z",
    ];
    const morphs = startPaths.map((startPath, index) => createPathMorph(startPath, endPaths[index]));
    const shapes = [p1, p2, p3, p4];

    return {
        node: svg,
        speed: 0.055,
        touchSpeed: 0.045,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const flow = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, flow);
            const opacity = mix(0.5, 1, flow);

            layer.setAttribute("opacity", String(opacity));

            shapes.forEach((shape, index) => {
                shape.setAttribute("stroke", color);
                shape.setAttribute("stroke-width", "4");
                shape.setAttribute("stroke-linecap", "round");
                shape.setAttribute("stroke-linejoin", "round");
                shape.setAttribute("stroke-dasharray", "1 12");
                shape.setAttribute("stroke-opacity", String(opacity));
                shape.setAttribute("d", morphs[index](flow));
            });
        },
    };
}

function renderBlindTasting() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makeCircle() {
        const circle = document.createElementNS(NS, "circle");
        circle.classList.add("animatedVisualSwap__vectorShape");
        circle.setAttribute("fill", "none");
        layer.appendChild(circle);
        return circle;
    }

    const outer = makeCircle();
    const middle = makeCircle();
    const inner = makeCircle();

    const start = {
        outer: { cx: 159.5, cy: 160, r: 112.0 },
        middle: { cx: 160, cy: 197, r: 75.0 },
        inner: { cx: 159.5, cy: 234.5, r: 37.5 },
    };
    const end = {
        outer: { cx: 159.5, cy: 160, r: 112.0 },
        middle: { cx: 160, cy: 160, r: 75.0 },
        inner: { cx: 159.5, cy: 159.5, r: 37.5 },
    };

    return {
        node: svg,
        speed: 0.055,
        touchSpeed: 0.045,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const flow = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, flow);
            const opacity = mix(0.5, 1, flow);

            layer.setAttribute("opacity", String(opacity));

            [outer, middle, inner].forEach((shape) => {
                shape.setAttribute("stroke", color);
                shape.setAttribute("stroke-width", "4");
                shape.setAttribute("stroke-linecap", "round");
                shape.setAttribute("stroke-linejoin", "round");
                shape.setAttribute("stroke-dasharray", "1 12");
                shape.setAttribute("stroke-opacity", String(opacity));
            });

            outer.setAttribute("cx", String(mix(start.outer.cx, end.outer.cx, flow)));
            outer.setAttribute("cy", String(mix(start.outer.cy, end.outer.cy, flow)));
            outer.setAttribute("r", String(mix(start.outer.r, end.outer.r, flow)));

            middle.setAttribute("cx", String(mix(start.middle.cx, end.middle.cx, flow)));
            middle.setAttribute("cy", String(mix(start.middle.cy, end.middle.cy, flow)));
            middle.setAttribute("r", String(mix(start.middle.r, end.middle.r, flow)));

            inner.setAttribute("cx", String(mix(start.inner.cx, end.inner.cx, flow)));
            inner.setAttribute("cy", String(mix(start.inner.cy, end.inner.cy, flow)));
            inner.setAttribute("r", String(mix(start.inner.r, end.inner.r, flow)));
        },
    };
}

function renderExportMarketVolumeEstimation() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makeCircle() {
        const circle = document.createElementNS(NS, "circle");
        circle.classList.add("animatedVisualSwap__vectorShape");
        circle.setAttribute("fill", "none");
        layer.appendChild(circle);
        return circle;
    }

    const c1 = makeCircle();
    const c2 = makeCircle();
    const c3 = makeCircle();
    const c4 = makeCircle();

    const start = {
        c1: { cx: 98.5, cy: 207.5, r: 37.5 },
        c2: { cx: 221.5, cy: 207.5, r: 37.5 },
        c3: { cx: 158.5, cy: 93.5, r: 37.5 },
        c4: { cx: 159.5, cy: 159.501, r: 137.5 },
    };
    const end = {
        c1: { cx: 118.5, cy: 188.5, r: 57.5 },
        c2: { cx: 201.5, cy: 188.5, r: 57.5 },
        c3: { cx: 158.5, cy: 115.5, r: 57.5 },
        c4: { cx: 159.5, cy: 159.501, r: 137.5 },
    };
    const circles = [
        [c1, start.c1, end.c1],
        [c2, start.c2, end.c2],
        [c3, start.c3, end.c3],
        [c4, start.c4, end.c4],
    ];

    return {
        node: svg,
        speed: 0.055,
        touchSpeed: 0.045,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const flow = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, flow);
            const opacity = mix(0.5, 1, flow);

            layer.setAttribute("opacity", String(opacity));

            circles.forEach(([node, from, to]) => {
                node.setAttribute("stroke", color);
                node.setAttribute("stroke-width", "4");
                node.setAttribute("stroke-linecap", "round");
                node.setAttribute("stroke-linejoin", "round");
                node.setAttribute("stroke-dasharray", "1 12");
                node.setAttribute("stroke-opacity", String(opacity));
                node.setAttribute("cx", String(mix(from.cx, to.cx, flow)));
                node.setAttribute("cy", String(mix(from.cy, to.cy, flow)));
                node.setAttribute("r", String(mix(from.r, to.r, flow)));
            });
        },
    };
}

function renderTargetMarketIdentification() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makeCircle() {
        const circle = document.createElementNS(NS, "circle");
        circle.classList.add("animatedVisualSwap__vectorShape");
        circle.setAttribute("fill", "none");
        layer.appendChild(circle);
        return circle;
    }

    function makeLine() {
        const line = document.createElementNS(NS, "line");
        line.classList.add("animatedVisualSwap__vectorShape");
        line.setAttribute("fill", "none");
        layer.appendChild(line);
        return line;
    }

    const c1 = makeCircle();
    const c2 = makeCircle();
    const c3 = makeCircle();
    const c4 = makeCircle();

    const l1 = makeLine();
    const l2 = makeLine();
    const l3 = makeLine();
    const l4 = makeLine();
    const l5 = makeLine();
    const l6 = makeLine();
    const l7 = makeLine();
    const l8 = makeLine();
    const l9 = makeLine();

    const startCircles = {
        c1: { cx: 159.5, cy: 160, r: 112.0 },
        c2: { cx: 160, cy: 197, r: 75.0 },
        c3: { cx: 159.5, cy: 234.5, r: 37.5 },
        c4: { cx: 159.5, cy: 160, r: 112.0 },
    };
    const endCircles = {
        c1: { cx: 159.5, cy: 160, r: 112.0 },
        c2: { cx: 160, cy: 160, r: 75.0 },
        c3: { cx: 159.5, cy: 159.5, r: 37.5 },
        c4: { cx: 159.5, cy: 160, r: 112.0 },
    };

    const lines = [
        { node: l1, start: [173, 205, 147, 205], end: [173, 130, 147, 130] },
        { node: l2, start: [173, 264, 147, 264], end: [173, 189, 147, 189] },
        { node: l3, start: [183, 213, 135, 213], end: [183, 138, 135, 138] },
        { node: l4, start: [183, 252, 135, 252], end: [183, 177, 135, 177] },
        { node: l5, start: [176, 258, 142, 258], end: [176, 183, 142, 183] },
        { node: l6, start: [189, 221, 130, 221], end: [189, 146, 130, 146] },
        { node: l7, start: [189, 245, 130, 245], end: [189, 170, 130, 170] },
        { node: l8, start: [191, 229, 128, 229], end: [191, 154, 128, 154] },
        { node: l9, start: [191, 237, 128, 237], end: [191, 162, 128, 162] },
    ];

    return {
        node: svg,
        speed: 0.055,
        touchSpeed: 0.045,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const flow = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, flow);
            const opacity = mix(0.5, 1, flow);

            layer.setAttribute("opacity", String(opacity));

            [c1, c2, c3, c4, ...lines.map((item) => item.node)].forEach((shape) => {
                shape.setAttribute("stroke", color);
                shape.setAttribute("stroke-width", "4");
                shape.setAttribute("stroke-linecap", "round");
                shape.setAttribute("stroke-linejoin", "round");
                shape.setAttribute("stroke-dasharray", "1 12");
                shape.setAttribute("stroke-opacity", String(opacity));
            });

            c1.setAttribute("cx", String(mix(startCircles.c1.cx, endCircles.c1.cx, flow)));
            c1.setAttribute("cy", String(mix(startCircles.c1.cy, endCircles.c1.cy, flow)));
            c1.setAttribute("r", String(mix(startCircles.c1.r, endCircles.c1.r, flow)));

            c2.setAttribute("cx", String(mix(startCircles.c2.cx, endCircles.c2.cx, flow)));
            c2.setAttribute("cy", String(mix(startCircles.c2.cy, endCircles.c2.cy, flow)));
            c2.setAttribute("r", String(mix(startCircles.c2.r, endCircles.c2.r, flow)));

            c3.setAttribute("cx", String(mix(startCircles.c3.cx, endCircles.c3.cx, flow)));
            c3.setAttribute("cy", String(mix(startCircles.c3.cy, endCircles.c3.cy, flow)));
            c3.setAttribute("r", String(mix(startCircles.c3.r, endCircles.c3.r, flow)));

            c4.setAttribute("cx", String(mix(startCircles.c4.cx, endCircles.c4.cx, flow)));
            c4.setAttribute("cy", String(mix(startCircles.c4.cy, endCircles.c4.cy, flow)));
            c4.setAttribute("r", String(mix(startCircles.c4.r, endCircles.c4.r, flow)));

            lines.forEach((item) => {
                item.node.setAttribute("x1", String(mix(item.start[0], item.end[0], flow)));
                item.node.setAttribute("y1", String(mix(item.start[1], item.end[1], flow)));
                item.node.setAttribute("x2", String(mix(item.start[2], item.end[2], flow)));
                item.node.setAttribute("y2", String(mix(item.start[3], item.end[3], flow)));
            });
        },
    };
}

function renderExportMarketResearch() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    const centerGroup = document.createElementNS(NS, "g");
    svg.appendChild(layer);
    layer.appendChild(centerGroup);

    function makePath(parent = layer) {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        parent.appendChild(path);
        return path;
    }

    const outerFrame = makePath();
    const innerFrame = makePath();
    const centerShape = makePath(centerGroup);

    const outerPath =
        "M276 40.6064H44.7969C42.5877 40.6064 40.7969 42.3973 40.7969 44.6064V276C40.7969 278.21 42.5877 280 44.7969 280H276C278.209 280 280 278.21 280 276V44.6064C280 42.3973 278.209 40.6064 276 40.6064Z";
    const innerPath =
        "M261 55H59C56.7909 55 55 56.7909 55 59V261C55 263.209 56.7909 265 59 265H261C263.209 265 265 263.209 265 261V59C265 56.7909 263.209 55 261 55Z";
    const centerPath =
        "M217.959 97.7285H101.728C99.5194 97.7285 97.7285 99.5194 97.7285 101.728V217.958C97.7285 220.167 99.5194 221.958 101.728 221.958H217.959C220.168 221.958 221.959 220.167 221.959 217.958V101.728C221.959 99.5194 220.168 97.7285 217.959 97.7285Z";

    return {
        node: svg,
        speed: 0.045,
        touchSpeed: 0.038,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const flow = smooth * smooth * (3 - 2 * smooth);
            const fluid = flow * flow * flow * (flow * (flow * 6 - 15) + 10);
            const spin = mix(-45, 0, fluid);
            const color = mixColor(INK, PINK, flow);
            const opacity = mix(0.5, 1, flow);

            layer.setAttribute("opacity", String(opacity));

            [outerFrame, innerFrame, centerShape].forEach((shape) => {
                shape.setAttribute("stroke", color);
                shape.setAttribute("stroke-width", "4");
                shape.setAttribute("stroke-linecap", "round");
                shape.setAttribute("stroke-linejoin", "round");
                shape.setAttribute("stroke-dasharray", "1 12");
                shape.setAttribute("stroke-opacity", String(opacity));
            });

            outerFrame.setAttribute("d", outerPath);
            innerFrame.setAttribute("d", innerPath);
            centerShape.setAttribute("d", centerPath);
            centerGroup.setAttribute("transform", `rotate(${spin} 160 160)`);
        },
    };
}

function renderTargetMarketPartnerIdentification() {
    const svg = createSvg();
    const layer = document.createElementNS(NS, "g");
    svg.appendChild(layer);

    function makePath() {
        const path = document.createElementNS(NS, "path");
        path.classList.add("animatedVisualSwap__vectorShape");
        path.setAttribute("fill", "none");
        layer.appendChild(path);
        return path;
    }

    function makeLine() {
        const line = document.createElementNS(NS, "line");
        line.classList.add("animatedVisualSwap__vectorShape");
        line.setAttribute("fill", "none");
        layer.appendChild(line);
        return line;
    }

    const core = makePath();
    const outerLeft = makePath();
    const outerRight = makePath();
    const outerTop = makePath();
    const l1 = makeLine();
    const l2 = makeLine();
    const l3 = makeLine();
    const l4 = makeLine();
    const l5 = makeLine();
    const l6 = makeLine();
    const l7 = makeLine();
    const l8 = makeLine();
    const l9 = makeLine();
    const l10 = makeLine();
    const l11 = makeLine();
    const l12 = makeLine();
    const l13 = makeLine();

    const coreStartPath =
        "M160 206C178.225 206 193 191.225 193 173C193 154.775 178.225 140 160 140C141.775 140 127 154.775 127 173C127 191.225 141.775 206 160 206Z";
    const coreEndPath =
        "M131.462 161.461C140.575 177.244 160.757 182.652 176.541 173.54C192.324 164.427 197.732 144.244 188.62 128.461C179.507 112.677 159.324 107.269 143.541 116.382C127.757 125.495 122.349 145.677 131.462 161.461Z";
    const coreMorph = createPathMorph(coreStartPath, coreEndPath);

    const outerLeftStartPath =
        "M102.981 261.998C104.086 261.989 104.989 262.876 104.999 263.98C105.008 265.085 104.12 265.989 103.016 265.998C102.844 266 102.672 266 102.5 266C102.328 266 102.156 266 101.984 265.998C100.88 265.989 99.9916 265.085 100.001 263.98C100.011 262.876 100.914 261.989 102.019 261.998C102.179 261.999 102.339 262 102.5 262C102.661 262 102.821 261.999 102.981 261.998ZM87.2695 261.997C87.5239 260.923 88.6011 260.258 89.6758 260.512C89.9862 260.585 90.298 260.655 90.6104 260.724C91.6895 260.959 92.3742 262.025 92.1387 263.104C91.9032 264.184 90.837 264.867 89.7578 264.632C89.4228 264.559 89.0888 264.483 88.7559 264.404C87.6809 264.15 87.0153 263.072 87.2695 261.997ZM115.324 260.512C116.399 260.258 117.476 260.923 117.73 261.997C117.985 263.072 117.319 264.15 116.244 264.404C115.911 264.483 115.577 264.559 115.242 264.632C114.163 264.867 113.097 264.184 112.861 263.104C112.626 262.025 113.31 260.959 114.39 260.724C114.702 260.655 115.014 260.585 115.324 260.512ZM75.3066 257.216C75.7952 256.225 76.9938 255.818 77.9844 256.307C78.2706 256.448 78.5587 256.586 78.8477 256.723C79.8465 257.194 80.274 258.386 79.8027 259.385C79.3314 260.384 78.1396 260.811 77.1406 260.34C76.8309 260.194 76.5226 260.045 76.2158 259.894C75.2252 259.405 74.8182 258.206 75.3066 257.216ZM127.016 256.307C128.006 255.818 129.205 256.225 129.693 257.216C130.182 258.206 129.775 259.405 128.784 259.894C128.477 260.045 128.169 260.194 127.859 260.34C126.86 260.811 125.669 260.384 125.197 259.385C124.726 258.386 125.154 257.194 126.152 256.723C126.441 256.586 126.729 256.448 127.016 256.307ZM64.71 249.885C65.4066 249.028 66.6662 248.897 67.5234 249.594C67.7712 249.795 68.0211 249.994 68.2725 250.191C69.1414 250.873 69.2931 252.131 68.6113 253C67.9295 253.869 66.6718 254.021 65.8027 253.339C65.5335 253.128 65.2664 252.914 65.001 252.698C64.1438 252.002 64.0133 250.742 64.71 249.885ZM137.477 249.594C138.334 248.897 139.593 249.028 140.29 249.885C140.987 250.742 140.856 252.002 139.999 252.698C139.734 252.914 139.466 253.128 139.197 253.339C138.328 254.021 137.07 253.869 136.389 253C135.707 252.131 135.859 250.873 136.728 250.191C136.979 249.994 137.229 249.795 137.477 249.594ZM56 240.389C56.869 239.707 58.1268 239.859 58.8086 240.728C59.0058 240.979 59.2049 241.229 59.4062 241.477C60.1029 242.334 59.9724 243.593 59.1152 244.29C58.258 244.987 56.9984 244.856 56.3018 243.999C56.0861 243.734 55.8723 243.466 55.6611 243.197C54.9793 242.328 55.131 241.07 56 240.389ZM146.191 240.728C146.873 239.859 148.131 239.707 149 240.389C149.869 241.07 150.021 242.328 149.339 243.197C149.128 243.466 148.914 243.734 148.698 243.999C148.002 244.856 146.742 244.987 145.885 244.29C145.028 243.593 144.897 242.334 145.594 241.477C145.795 241.229 145.994 240.979 146.191 240.728ZM49.6152 229.197C50.6141 228.726 51.806 229.154 52.2773 230.152C52.4137 230.441 52.5522 230.729 52.6934 231.016C53.1818 232.006 52.7748 233.205 51.7842 233.693C50.7936 234.182 49.595 233.775 49.1064 232.784C48.9551 232.477 48.8063 232.169 48.6602 231.859C48.1888 230.86 48.6163 229.669 49.6152 229.197ZM152.723 230.152C153.194 229.154 154.386 228.726 155.385 229.197C156.384 229.669 156.811 230.86 156.34 231.859C156.194 232.169 156.045 232.477 155.894 232.784C155.405 233.775 154.206 234.182 153.216 233.693C152.225 233.205 151.818 232.006 152.307 231.016C152.448 230.729 152.586 230.441 152.723 230.152ZM45.8955 216.861C46.9747 216.626 48.0409 217.31 48.2764 218.39C48.3445 218.702 48.4149 219.014 48.4883 219.324C48.7423 220.399 48.0775 221.476 47.0029 221.73C45.928 221.985 44.8499 221.319 44.5957 220.244C44.517 219.911 44.4413 219.577 44.3682 219.242C44.1327 218.163 44.8163 217.097 45.8955 216.861ZM156.724 218.39C156.959 217.31 158.025 216.626 159.104 216.861C160.184 217.097 160.867 218.163 160.632 219.242C160.559 219.577 160.483 219.911 160.404 220.244C160.15 221.319 159.072 221.985 157.997 221.73C156.923 221.476 156.258 220.399 156.512 219.324C156.585 219.014 156.655 218.702 156.724 218.39ZM45.0195 204.001C46.1239 204.011 47.0113 204.914 47.002 206.019C47.0006 206.179 47 206.339 47 206.5C47 206.661 47.0006 206.821 47.002 206.981C47.0113 208.086 46.1239 208.989 45.0195 208.999C43.915 209.008 43.0113 208.12 43.002 207.016C43.0005 206.844 43 206.672 43 206.5C43 206.328 43.0005 206.156 43.002 205.984C43.0113 204.88 43.915 203.992 45.0195 204.001ZM158.03 207.351C158.389 207.74 158.899 207.988 159.47 207.996C159.646 207.999 159.823 208 160 208C160.177 208 160.354 207.999 160.53 207.996C161.098 207.988 161.606 207.742 161.964 207.356C161.794 208.297 160.969 209.007 159.98 208.999C159.002 208.991 158.196 208.28 158.03 207.351ZM44.5957 192.756C44.8499 191.681 45.928 191.015 47.0029 191.27C48.0775 191.524 48.7423 192.601 48.4883 193.676C48.4149 193.986 48.3445 194.298 48.2764 194.61C48.0409 195.69 46.9747 196.374 45.8955 196.139C44.8163 195.903 44.1327 194.837 44.3682 193.758C44.4413 193.423 44.517 193.089 44.5957 192.756ZM49.1064 180.216C49.595 179.225 50.7936 178.818 51.7842 179.307C52.7748 179.795 53.1819 180.994 52.6934 181.984C52.5522 182.271 52.4137 182.559 52.2773 182.848C51.806 183.846 50.6141 184.274 49.6152 183.803C48.6163 183.331 48.1888 182.14 48.6602 181.141C48.8063 180.831 48.9551 180.523 49.1064 180.216ZM56.3018 169.001C56.9984 168.144 58.258 168.013 59.1152 168.71C59.9724 169.407 60.1029 170.666 59.4062 171.523C59.2049 171.771 59.0058 172.021 58.8086 172.272C58.1268 173.141 56.869 173.293 56 172.611C55.131 171.93 54.9793 170.672 55.6611 169.803C55.8723 169.534 56.0861 169.266 56.3018 169.001ZM65.8027 159.661C66.6718 158.979 67.9295 159.131 68.6113 160C69.2931 160.869 69.1414 162.127 68.2725 162.809C68.0211 163.006 67.7712 163.205 67.5234 163.406C66.6662 164.103 65.4066 163.972 64.71 163.115C64.0133 162.258 64.1438 160.998 65.001 160.302C65.2664 160.086 65.5335 159.872 65.8027 159.661ZM77.1406 152.66C78.1396 152.189 79.3314 152.616 79.8027 153.615C80.274 154.614 79.8465 155.806 78.8477 156.277C78.5587 156.414 78.2706 156.552 77.9844 156.693C76.9938 157.182 75.7952 156.775 75.3066 155.784C74.8182 154.794 75.2252 153.595 76.2158 153.106C76.5226 152.955 76.8309 152.806 77.1406 152.66ZM125.197 153.615C125.669 152.616 126.86 152.189 127.859 152.66C128.169 152.806 128.477 152.955 128.784 153.106C129.775 153.595 130.182 154.794 129.693 155.784C129.205 156.775 128.006 157.182 127.016 156.693C126.729 156.552 126.441 156.414 126.152 156.277C125.154 155.806 124.726 154.614 125.197 153.615ZM89.7578 148.368C90.837 148.133 91.9032 148.816 92.1387 149.896C92.3742 150.975 91.6895 152.041 90.6104 152.276C90.298 152.345 89.9862 152.415 89.6758 152.488C88.6011 152.742 87.5239 152.077 87.2695 151.003C87.0153 149.928 87.6809 148.85 88.7559 148.596C89.0888 148.517 89.4228 148.441 89.7578 148.368ZM112.861 149.896C113.097 148.816 114.163 148.133 115.242 148.368C115.577 148.441 115.911 148.517 116.244 148.596C117.319 148.85 117.985 149.928 117.73 151.003C117.476 152.077 116.399 152.742 115.324 152.488C115.014 152.415 114.702 152.345 114.39 152.276C113.31 152.041 112.626 150.975 112.861 149.896ZM103.016 147.002C104.12 147.011 105.008 147.915 104.999 149.02C104.989 150.124 104.086 151.011 102.981 151.002C102.821 151.001 102.661 151 102.5 151C102.339 151 102.179 151.001 102.019 151.002C100.914 151.011 100.011 150.124 100.001 149.02C99.9916 147.915 100.88 147.011 101.984 147.002C102.156 147 102.328 147 102.5 147C102.672 147 102.844 147 103.016 147.002Z";
    const outerRightStartPath =
        "M217.981 261.998C219.086 261.989 219.989 262.876 219.999 263.98C220.008 265.085 219.12 265.989 218.016 265.998C217.844 266 217.672 266 217.5 266C217.328 266 217.156 266 216.984 265.998C215.88 265.989 214.992 265.085 215.001 263.98C215.011 262.876 215.914 261.989 217.019 261.998C217.179 261.999 217.339 262 217.5 262C217.661 262 217.821 261.999 217.981 261.998ZM202.27 261.997C202.524 260.923 203.601 260.258 204.676 260.512C204.986 260.585 205.298 260.655 205.61 260.724C206.69 260.959 207.374 262.025 207.139 263.104C206.903 264.184 205.837 264.867 204.758 264.632C204.423 264.559 204.089 264.483 203.756 264.404C202.681 264.15 202.015 263.072 202.27 261.997ZM230.324 260.512C231.399 260.258 232.476 260.923 232.73 261.997C232.985 263.072 232.319 264.15 231.244 264.404C230.911 264.483 230.577 264.559 230.242 264.632C229.163 264.867 228.097 264.184 227.861 263.104C227.626 262.025 228.31 260.959 229.39 260.724C229.702 260.655 230.014 260.585 230.324 260.512ZM190.307 257.216C190.795 256.225 191.994 255.818 192.984 256.307C193.271 256.448 193.559 256.586 193.848 256.723C194.846 257.194 195.274 258.386 194.803 259.385C194.331 260.384 193.14 260.811 192.141 260.34C191.831 260.194 191.523 260.045 191.216 259.894C190.225 259.405 189.818 258.206 190.307 257.216ZM242.016 256.307C243.006 255.818 244.205 256.225 244.693 257.216C245.182 258.206 244.775 259.405 243.784 259.894C243.477 260.045 243.169 260.194 242.859 260.34C241.86 260.811 240.669 260.384 240.197 259.385C239.726 258.386 240.154 257.194 241.152 256.723C241.441 256.586 241.729 256.448 242.016 256.307ZM179.71 249.885C180.407 249.028 181.666 248.897 182.523 249.594C182.771 249.795 183.021 249.994 183.272 250.191C184.141 250.873 184.293 252.131 183.611 253C182.93 253.869 181.672 254.021 180.803 253.339C180.534 253.128 180.266 252.914 180.001 252.698C179.144 252.002 179.013 250.742 179.71 249.885ZM252.477 249.594C253.334 248.897 254.593 249.028 255.29 249.885C255.987 250.742 255.856 252.002 254.999 252.698C254.734 252.914 254.466 253.128 254.197 253.339C253.328 254.021 252.07 253.869 251.389 253C250.707 252.131 250.859 250.873 251.728 250.191C251.979 249.994 252.229 249.795 252.477 249.594ZM171 240.389C171.869 239.707 173.127 239.859 173.809 240.728C174.006 240.979 174.205 241.229 174.406 241.477C175.103 242.334 174.972 243.593 174.115 244.29C173.258 244.987 171.998 244.856 171.302 243.999C171.086 243.734 170.872 243.466 170.661 243.197C169.979 242.328 170.131 241.07 171 240.389ZM261.191 240.728C261.873 239.859 263.131 239.707 264 240.389C264.869 241.07 265.021 242.328 264.339 243.197C264.128 243.466 263.914 243.734 263.698 243.999C263.002 244.856 261.742 244.987 260.885 244.29C260.028 243.593 259.897 242.334 260.594 241.477C260.795 241.229 260.994 240.979 261.191 240.728ZM164.615 229.197C165.614 228.726 166.806 229.154 167.277 230.152C167.414 230.441 167.552 230.729 167.693 231.016C168.182 232.006 167.775 233.205 166.784 233.693C165.794 234.182 164.595 233.775 164.106 232.784C163.955 232.477 163.806 232.169 163.66 231.859C163.189 230.86 163.616 229.669 164.615 229.197ZM267.723 230.152C268.194 229.154 269.386 228.726 270.385 229.197C271.384 229.669 271.811 230.86 271.34 231.859C271.194 232.169 271.045 232.477 270.894 232.784C270.405 233.775 269.206 234.182 268.216 233.693C267.225 233.205 266.818 232.006 267.307 231.016C267.448 230.729 267.586 230.441 267.723 230.152ZM160.896 216.861C161.975 216.626 163.041 217.31 163.276 218.39C163.345 218.702 163.415 219.014 163.488 219.324C163.742 220.399 163.077 221.476 162.003 221.73C160.928 221.985 159.85 221.319 159.596 220.244C159.517 219.911 159.441 219.577 159.368 219.242C159.133 218.163 159.816 217.097 160.896 216.861ZM271.724 218.39C271.959 217.31 273.025 216.626 274.104 216.861C275.184 217.097 275.867 218.163 275.632 219.242C275.559 219.577 275.483 219.911 275.404 220.244C275.15 221.319 274.072 221.985 272.997 221.73C271.923 221.476 271.258 220.399 271.512 219.324C271.585 219.014 271.655 218.702 271.724 218.39ZM161.969 207.351C161.803 208.28 160.998 208.991 160.02 208.999C159.031 209.007 158.205 208.297 158.035 207.356C158.393 207.742 158.902 207.988 159.47 207.996C159.646 207.999 159.823 208 160 208C160.177 208 160.354 207.999 160.53 207.996C161.101 207.988 161.61 207.739 161.969 207.351ZM274.98 204.001C276.085 203.992 276.989 204.88 276.998 205.984C277 206.156 277 206.328 277 206.5C277 206.672 277 206.844 276.998 207.016C276.989 208.12 276.085 209.008 274.98 208.999C273.876 208.989 272.989 208.086 272.998 206.981C272.999 206.821 273 206.661 273 206.5C273 206.339 272.999 206.179 272.998 206.019C272.989 204.914 273.876 204.011 274.98 204.001ZM272.997 191.27C274.072 191.015 275.15 191.681 275.404 192.756C275.483 193.089 275.559 193.423 275.632 193.758C275.867 194.837 275.184 195.903 274.104 196.139C273.025 196.374 271.959 195.69 271.724 194.61C271.655 194.298 271.585 193.986 271.512 193.676C271.258 192.601 271.923 191.524 272.997 191.27ZM268.216 179.307C269.206 178.818 270.405 179.225 270.894 180.216C271.045 180.523 271.194 180.831 271.34 181.141C271.811 182.14 271.384 183.331 270.385 183.803C269.386 184.274 268.194 183.846 267.723 182.848C267.586 182.559 267.448 182.271 267.307 181.984C266.818 180.994 267.225 179.795 268.216 179.307ZM260.885 168.71C261.742 168.013 263.002 168.144 263.698 169.001C263.914 169.266 264.128 169.534 264.339 169.803C265.021 170.672 264.869 171.93 264 172.611C263.131 173.293 261.873 173.141 261.191 172.272C260.994 172.021 260.795 171.771 260.594 171.523C259.897 170.666 260.028 169.407 260.885 168.71ZM251.389 160C252.07 159.131 253.328 158.979 254.197 159.661C254.466 159.872 254.734 160.086 254.999 160.302C255.856 160.998 255.987 162.258 255.29 163.115C254.593 163.972 253.334 164.103 252.477 163.406C252.229 163.205 251.979 163.006 251.728 162.809C250.859 162.127 250.707 160.869 251.389 160ZM192.141 152.66C193.14 152.189 194.331 152.616 194.803 153.615C195.274 154.614 194.846 155.806 193.848 156.277C193.559 156.414 193.271 156.552 192.984 156.693C191.994 157.182 190.795 156.775 190.307 155.784C189.818 154.794 190.225 153.595 191.216 153.106C191.523 152.955 191.831 152.806 192.141 152.66ZM240.197 153.615C240.669 152.616 241.86 152.189 242.859 152.66C243.169 152.806 243.477 152.955 243.784 153.106C244.775 153.595 245.182 154.794 244.693 155.784C244.205 156.775 243.006 157.182 242.016 156.693C241.729 156.552 241.441 156.414 241.152 156.277C240.154 155.806 239.726 154.614 240.197 153.615ZM204.758 148.368C205.837 148.133 206.903 148.816 207.139 149.896C207.374 150.975 206.69 152.041 205.61 152.276C205.298 152.345 204.986 152.415 204.676 152.488C203.601 152.742 202.524 152.077 202.27 151.003C202.015 149.928 202.681 148.85 203.756 148.596C204.089 148.517 204.423 148.441 204.758 148.368ZM227.861 149.896C228.097 148.816 229.163 148.133 230.242 148.368C230.577 148.441 230.911 148.517 231.244 148.596C232.319 148.85 232.985 149.928 232.73 151.003C232.476 152.077 231.399 152.742 230.324 152.488C230.014 152.415 229.702 152.345 229.39 152.276C228.31 152.041 227.626 150.975 227.861 149.896ZM218.016 147.002C219.12 147.011 220.008 147.915 219.999 149.02C219.989 150.124 219.086 151.011 217.981 151.002C217.821 151.001 217.661 151 217.5 151C217.339 151 217.179 151.001 217.019 151.002C215.914 151.011 215.011 150.124 215.001 149.02C214.992 147.915 215.88 147.011 216.984 147.002C217.156 147 217.328 147 217.5 147C217.672 147 217.844 147 218.016 147.002Z";
    const outerTopStartPath =
        "M121.71 149.885C122.407 149.028 123.666 148.897 124.523 149.594C124.771 149.795 125.021 149.994 125.272 150.191C126.141 150.873 126.293 152.131 125.611 153C124.93 153.869 123.672 154.021 122.803 153.339C122.534 153.128 122.266 152.914 122.001 152.698C121.144 152.002 121.013 150.742 121.71 149.885ZM194.477 149.594C195.334 148.897 196.593 149.028 197.29 149.885C197.987 150.742 197.856 152.002 196.999 152.698C196.734 152.914 196.466 153.128 196.197 153.339C195.328 154.021 194.07 153.869 193.389 153C192.707 152.131 192.859 150.873 193.728 150.191C193.979 149.994 194.229 149.795 194.477 149.594ZM113 140.389C113.869 139.707 115.127 139.859 115.809 140.728C116.006 140.979 116.205 141.229 116.406 141.477C117.103 142.334 116.972 143.593 116.115 144.29C115.258 144.987 113.998 144.856 113.302 143.999C113.086 143.734 112.872 143.466 112.661 143.197C111.979 142.328 112.131 141.07 113 140.389ZM203.191 140.728C203.873 139.859 205.131 139.707 206 140.389C206.869 141.07 207.021 142.328 206.339 143.197C206.128 143.466 205.914 143.734 205.698 143.999C205.002 144.856 203.742 144.987 202.885 144.29C202.028 143.593 201.897 142.334 202.594 141.477C202.795 141.229 202.994 140.979 203.191 140.728ZM106.615 129.197C107.614 128.726 108.806 129.154 109.277 130.152C109.414 130.441 109.552 130.729 109.693 131.016C110.182 132.006 109.775 133.205 108.784 133.693C107.794 134.182 106.595 133.775 106.106 132.784C105.955 132.477 105.806 132.169 105.66 131.859C105.189 130.86 105.616 129.669 106.615 129.197ZM209.723 130.152C210.194 129.154 211.386 128.726 212.385 129.197C213.384 129.669 213.811 130.86 213.34 131.859C213.194 132.169 213.045 132.477 212.894 132.784C212.405 133.775 211.206 134.182 210.216 133.693C209.225 133.205 208.818 132.006 209.307 131.016C209.448 130.729 209.586 130.441 209.723 130.152ZM102.896 116.861C103.975 116.626 105.041 117.31 105.276 118.39C105.345 118.702 105.415 119.014 105.488 119.324C105.742 120.399 105.077 121.476 104.003 121.73C102.928 121.985 101.85 121.319 101.596 120.244C101.517 119.911 101.441 119.577 101.368 119.242C101.133 118.163 101.816 117.097 102.896 116.861ZM213.724 118.39C213.959 117.31 215.025 116.626 216.104 116.861C217.184 117.097 217.867 118.163 217.632 119.242C217.559 119.577 217.483 119.911 217.404 120.244C217.15 121.319 216.072 121.985 214.997 121.73C213.923 121.476 213.258 120.399 213.512 119.324C213.585 119.014 213.655 118.702 213.724 118.39ZM102.02 104.001C103.124 104.011 104.011 104.914 104.002 106.019C104.001 106.179 104 106.339 104 106.5C104 106.661 104.001 106.821 104.002 106.981C104.011 108.086 103.124 108.989 102.02 108.999C100.915 109.008 100.011 108.12 100.002 107.016C100 106.844 100 106.672 100 106.5C100 106.328 100 106.156 100.002 105.984C100.011 104.88 100.915 103.992 102.02 104.001ZM216.98 104.001C218.085 103.992 218.989 104.88 218.998 105.984C219 106.156 219 106.328 219 106.5C219 106.672 219 106.844 218.998 107.016C218.989 108.12 218.085 109.008 216.98 108.999C215.876 108.989 214.989 108.086 214.998 106.981C214.999 106.821 215 106.661 215 106.5C215 106.339 214.999 106.179 214.998 106.019C214.989 104.914 215.876 104.011 216.98 104.001ZM101.596 92.7559C101.85 91.6809 102.928 91.0153 104.003 91.2695C105.077 91.5239 105.742 92.6011 105.488 93.6758C105.415 93.9862 105.345 94.298 105.276 94.6104C105.041 95.6895 103.975 96.3742 102.896 96.1387C101.816 95.9032 101.133 94.837 101.368 93.7578C101.441 93.4228 101.517 93.0888 101.596 92.7559ZM214.997 91.2695C216.072 91.0153 217.15 91.6809 217.404 92.7559C217.483 93.0888 217.559 93.4228 217.632 93.7578C217.867 94.837 217.184 95.9032 216.104 96.1387C215.025 96.3742 213.959 95.6895 213.724 94.6104C213.655 94.298 213.585 93.9862 213.512 93.6758C213.258 92.6011 213.923 91.5239 214.997 91.2695ZM106.106 80.2158C106.595 79.2252 107.794 78.8182 108.784 79.3066C109.775 79.7952 110.182 80.9938 109.693 81.9844C109.552 82.2706 109.414 82.5587 109.277 82.8477C108.806 83.8465 107.614 84.274 106.615 83.8027C105.616 83.3314 105.189 82.1396 105.66 81.1406C105.806 80.8309 105.955 80.5226 106.106 80.2158ZM210.216 79.3066C211.206 78.8182 212.405 79.2252 212.894 80.2158C213.045 80.5226 213.194 80.8309 213.34 81.1406C213.811 82.1396 213.384 83.3314 212.385 83.8027C211.386 84.274 210.194 83.8465 209.723 82.8477C209.586 82.5587 209.448 82.2706 209.307 81.9844C208.818 80.9938 209.225 79.7952 210.216 79.3066ZM113.302 69.001C113.998 68.1438 115.258 68.0133 116.115 68.71C116.972 69.4066 117.103 70.6662 116.406 71.5234C116.205 71.7712 116.006 72.0211 115.809 72.2725C115.127 73.1414 113.869 73.2931 113 72.6113C112.131 71.9295 111.979 70.6718 112.661 69.8027C112.872 69.5335 113.086 69.2664 113.302 69.001ZM202.885 68.71C203.742 68.0133 205.002 68.1438 205.698 69.001C205.914 69.2664 206.128 69.5335 206.339 69.8027C207.021 70.6718 206.869 71.9295 206 72.6113C205.131 73.2931 203.873 73.1414 203.191 72.2725C202.994 72.0211 202.795 71.7712 202.594 71.5234C201.897 70.6662 202.028 69.4066 202.885 68.71ZM122.803 59.6611C123.672 58.9793 124.93 59.131 125.611 60C126.293 60.869 126.141 62.1268 125.272 62.8086C125.021 63.0058 124.771 63.2049 124.523 63.4062C123.666 64.1029 122.407 63.9724 121.71 63.1152C121.013 62.258 121.144 60.9984 122.001 60.3018C122.266 60.0861 122.534 59.8723 122.803 59.6611ZM193.389 60C194.07 59.131 195.328 58.9793 196.197 59.6611C196.466 59.8723 196.734 60.0861 196.999 60.3018C197.856 60.9984 197.987 62.258 197.29 63.1152C196.593 63.9724 195.334 64.1029 194.477 63.4062C194.229 63.2049 193.979 63.0058 193.728 62.8086C192.859 62.1268 192.707 60.869 193.389 60ZM134.141 52.6602C135.14 52.1888 136.331 52.6163 136.803 53.6152C137.274 54.6141 136.846 55.806 135.848 56.2773C135.559 56.4137 135.271 56.5522 134.984 56.6934C133.994 57.1819 132.795 56.7748 132.307 55.7842C131.818 54.7936 132.225 53.595 133.216 53.1064C133.523 52.9551 133.831 52.8063 134.141 52.6602ZM182.197 53.6152C182.669 52.6163 183.86 52.1888 184.859 52.6602C185.169 52.8063 185.477 52.9551 185.784 53.1064C186.775 53.595 187.182 54.7936 186.693 55.7842C186.205 56.7748 185.006 57.1819 184.016 56.6934C183.729 56.5522 183.441 56.4137 183.152 56.2773C182.154 55.806 181.726 54.6141 182.197 53.6152ZM146.758 48.3682C147.837 48.1327 148.903 48.8163 149.139 49.8955C149.374 50.9747 148.69 52.0409 147.61 52.2764C147.298 52.3445 146.986 52.4149 146.676 52.4883C145.601 52.7423 144.524 52.0775 144.27 51.0029C144.015 49.928 144.681 48.8499 145.756 48.5957C146.089 48.517 146.423 48.4413 146.758 48.3682ZM169.861 49.8955C170.097 48.8163 171.163 48.1327 172.242 48.3682C172.577 48.4413 172.911 48.517 173.244 48.5957C174.319 48.8499 174.985 49.928 174.73 51.0029C174.476 52.0775 173.399 52.7423 172.324 52.4883C172.014 52.4149 171.702 52.3445 171.39 52.2764C170.31 52.0409 169.626 50.9747 169.861 49.8955ZM160.016 47.002C161.12 47.0113 162.008 47.915 161.999 49.0195C161.989 50.1239 161.086 51.0113 159.981 51.002C159.821 51.0006 159.661 51 159.5 51C159.339 51 159.179 51.0006 159.019 51.002C157.914 51.0113 157.011 50.1239 157.001 49.0195C156.992 47.915 157.88 47.0113 158.984 47.002C159.156 47.0005 159.328 47 159.5 47C159.672 47 159.844 47.0005 160.016 47.002Z";

    const outerLeftEndPath =
        "M54.4571 140.08C55.0174 141.032 54.7006 142.258 53.7491 142.819C52.7972 143.379 51.5705 143.062 51.0101 142.11C50.923 141.962 50.8366 141.813 50.7506 141.664C50.6646 141.515 50.5791 141.366 50.4945 141.217C49.9503 140.255 50.2888 139.034 51.25 138.49C52.2112 137.946 53.4316 138.285 53.9757 139.246C54.0546 139.386 54.1344 139.525 54.2147 139.664C54.295 139.803 54.3758 139.942 54.4571 140.08ZM46.602 126.473C47.6598 126.156 48.7741 126.756 49.0915 127.814C49.1831 128.12 49.2781 128.425 49.3752 128.729C49.7109 129.782 49.1298 130.908 48.0775 131.243C47.0252 131.579 45.9 130.997 45.5644 129.945C45.4602 129.618 45.3587 129.291 45.2604 128.964C44.9431 127.906 45.544 126.79 46.602 126.473ZM61.9157 150.026C62.673 150.83 62.6359 152.095 61.8325 152.853C61.0287 153.61 59.7622 153.573 59.0046 152.769C58.7699 152.52 58.5374 152.269 58.3065 152.015C57.563 151.198 57.622 149.933 58.4388 149.19C59.2557 148.446 60.5213 148.506 61.2649 149.323C61.4801 149.559 61.6969 149.794 61.9157 150.026ZM44.7612 113.722C45.8634 113.65 46.8152 114.484 46.8875 115.586C46.9083 115.905 46.9324 116.224 46.9588 116.542C47.05 117.643 46.2316 118.609 45.1309 118.7C44.0301 118.792 43.064 117.973 42.9727 116.872C42.9444 116.531 42.9192 116.19 42.8968 115.848C42.8246 114.746 43.6591 113.794 44.7612 113.722ZM71.4031 158.049C72.3214 158.662 72.5682 159.904 71.9546 160.822C71.3409 161.741 70.0994 161.987 69.181 161.374C68.8966 161.184 68.6136 160.991 68.3321 160.796C67.4245 160.167 67.1987 158.921 67.8282 158.013C68.4576 157.105 69.7035 156.88 70.6112 157.509C70.8737 157.691 71.1377 157.871 71.4031 158.049ZM45.8118 100.88C46.9024 101.054 47.6452 102.08 47.4705 103.171C47.42 103.486 47.3726 103.802 47.3275 104.118C47.1715 105.211 46.158 105.972 45.0646 105.816C43.9711 105.66 43.2109 104.646 43.3668 103.553C43.4151 103.214 43.4666 102.876 43.5207 102.538C43.6954 101.448 44.7211 100.705 45.8118 100.88ZM82.4471 163.752C83.479 164.146 83.9959 165.302 83.6018 166.334C83.2078 167.366 82.0517 167.883 81.0198 167.488C80.7002 167.366 80.3816 167.242 80.0641 167.114C79.0391 166.703 78.5415 165.538 78.9533 164.513C79.365 163.488 80.5301 162.99 81.555 163.402C81.8514 163.521 82.1488 163.638 82.4471 163.752ZM49.6807 88.5884C50.7056 89.0001 51.2031 90.1652 50.7915 91.1902C50.6724 91.4866 50.5555 91.7839 50.4416 92.0823C50.0476 93.1141 48.8915 93.631 47.8596 93.237C46.8277 92.8429 46.3108 91.6868 46.7049 90.6549C46.8269 90.3354 46.9514 90.0167 47.0789 89.6992C47.4906 88.6743 48.6557 88.1767 49.6807 88.5884ZM94.4829 166.866C95.5763 167.022 96.3366 168.035 96.1806 169.129C96.0247 170.222 95.0113 170.982 93.9178 170.827C93.579 170.778 93.2408 170.727 92.9031 170.673C91.8124 170.498 91.0697 169.472 91.2443 168.382C91.419 167.291 92.4447 166.548 93.5354 166.723C93.8507 166.773 94.1667 166.821 94.4829 166.866ZM56.1803 77.4633C57.0879 78.0928 57.3135 79.3387 56.6842 80.2463C56.5022 80.5089 56.3219 80.7729 56.1446 81.0382C55.531 81.9566 54.2895 82.2034 53.3711 81.5897C52.4527 80.9761 52.206 79.7346 52.8196 78.8162C53.0096 78.5317 53.2021 78.2487 53.3973 77.9673C54.0268 77.0596 55.2727 76.8339 56.1803 77.4633ZM106.907 167.235C108.008 167.143 108.974 167.962 109.065 169.062C109.156 170.163 108.338 171.129 107.237 171.221C106.896 171.249 106.554 171.274 106.213 171.297C105.111 171.369 104.159 170.534 104.087 169.432C104.015 168.33 104.849 167.378 105.951 167.306C106.27 167.285 106.588 167.261 106.907 167.235ZM65.0037 68.074C65.7472 68.8908 65.6874 70.1565 64.8705 70.9C64.6341 71.1153 64.3992 71.3321 64.1671 71.5508C63.3634 72.3082 62.0982 72.271 61.3406 71.4676C60.583 70.6638 60.6204 69.3974 61.4242 68.6397C61.6731 68.4051 61.9245 68.1725 62.1781 67.9417C62.995 67.1982 64.2602 67.2571 65.0037 68.074ZM119.094 164.818C120.147 164.482 121.273 165.064 121.608 166.116C121.944 167.168 121.362 168.293 120.31 168.629C119.983 168.733 119.656 168.835 119.328 168.933C118.27 169.25 117.155 168.649 116.838 167.591C116.521 166.534 117.121 165.419 118.179 165.102C118.484 165.01 118.79 164.915 119.094 164.818ZM75.7031 60.8852C76.2469 61.8464 75.9081 63.0667 74.947 63.6108C74.8075 63.6898 74.6682 63.7695 74.5291 63.8498C74.39 63.9302 74.2513 64.0109 74.1131 64.0923C73.1614 64.6526 71.9351 64.3358 71.3747 63.3842C70.8143 62.4324 71.1317 61.2056 72.0835 60.6452C72.2315 60.5581 72.3801 60.4718 72.5291 60.3857C72.6781 60.2997 72.8272 60.2142 72.9766 60.1296C73.9379 59.5855 75.1589 59.924 75.7031 60.8852ZM129.308 160.43C129.15 160.935 129.19 161.501 129.468 162C129.554 162.154 129.642 162.307 129.73 162.461C129.819 162.614 129.908 162.767 129.999 162.918C130.29 163.406 130.756 163.722 131.269 163.84C130.37 164.163 129.342 163.803 128.855 162.943C128.373 162.092 128.585 161.038 129.308 160.43ZM85.2297 54.8956C86.2877 54.5783 87.4032 55.1791 87.7205 56.2371C88.0375 57.2949 87.437 58.4093 86.3793 58.7266C86.0738 58.8182 85.7686 58.9132 85.464 59.0104C84.4117 59.346 83.2857 58.765 82.95 57.7127C82.6144 56.6603 83.1959 55.5352 84.2482 55.1995C84.5749 55.0953 84.9021 54.9939 85.2297 54.8956ZM98.3451 52.532C99.4472 52.4598 100.399 53.2943 100.471 54.3964C100.544 55.4986 99.7091 56.4504 98.6069 56.5226C98.2885 56.5435 97.9697 56.5676 97.6513 56.594C96.5506 56.6852 95.5844 55.8668 95.4931 54.7661C95.4018 53.6653 96.2203 52.6992 97.321 52.6079C97.6624 52.5796 98.0037 52.5544 98.3451 52.532ZM111.655 53.1559C112.746 53.3306 113.489 54.3563 113.314 55.4469C113.139 56.5376 112.113 57.2804 111.023 57.1057C110.708 57.0552 110.392 57.0077 110.075 56.9626C108.982 56.8066 108.222 55.7932 108.378 54.6997C108.533 53.6062 109.547 52.846 110.64 53.002C110.979 53.0503 111.317 53.1018 111.655 53.1559ZM124.494 56.7141C125.519 57.1258 126.017 58.2908 125.605 59.3158C125.193 60.3407 124.028 60.8382 123.003 60.4266C122.707 60.3076 122.409 60.1907 122.111 60.0768C121.079 59.6827 120.562 58.5266 120.956 57.4947C121.35 56.4628 122.507 55.946 123.538 56.34C123.858 56.462 124.177 56.5865 124.494 56.7141ZM136.226 63.0325C137.134 63.6619 137.359 64.9078 136.73 65.8155C136.101 66.7231 134.855 66.9487 133.947 66.3194C133.684 66.1373 133.42 65.9571 133.155 65.7798C132.237 65.1661 131.99 63.9246 132.604 63.0062C133.217 62.0879 134.459 61.8411 135.377 62.4547C135.662 62.6448 135.945 62.8373 136.226 63.0325ZM159.427 105.128C160.528 105.037 161.494 105.855 161.585 106.956C161.614 107.298 161.639 107.639 161.661 107.98C161.734 109.082 160.899 110.034 159.797 110.106C158.695 110.179 157.743 109.344 157.671 108.242C157.65 107.924 157.626 107.605 157.599 107.286C157.508 106.186 158.327 105.22 159.427 105.128ZM146.252 71.8133C146.995 72.6301 146.936 73.8953 146.119 74.6388C145.303 75.3824 144.037 75.3225 143.293 74.5057C143.078 74.2692 142.861 74.0344 142.643 73.8023C141.885 72.9986 141.922 71.7333 142.726 70.9757C143.53 70.2181 144.796 70.2555 145.554 71.0593C145.788 71.3083 146.021 71.5597 146.252 71.8133ZM156.481 92.5852C157.533 92.2495 158.658 92.8311 158.994 93.8834C159.098 94.2101 159.199 94.5372 159.298 94.8649C159.615 95.9229 159.014 97.0384 157.956 97.3557C156.898 97.6727 155.784 97.0722 155.467 96.0145C155.375 95.709 155.28 95.4038 155.183 95.0992C154.847 94.0468 155.428 92.9208 156.481 92.5852ZM154.064 82.6118C154.608 83.573 154.269 84.7941 153.308 85.3382C152.347 85.8821 151.127 85.5433 150.583 84.5822C150.504 84.4427 150.424 84.3034 150.344 84.1643C150.263 84.0251 150.182 83.8864 150.101 83.7483C149.541 82.7966 149.858 81.5703 150.809 81.0098C151.761 80.4494 152.988 80.7668 153.548 81.7187C153.635 81.8667 153.722 82.0153 153.808 82.1643C153.894 82.3132 153.979 82.4623 154.064 82.6118Z";
    const outerRightEndPath =
        "M111.957 239.674C112.517 240.626 112.201 241.852 111.249 242.412C110.297 242.973 109.07 242.655 108.51 241.703C108.423 241.555 108.337 241.407 108.251 241.258C108.165 241.109 108.079 240.96 107.994 240.81C107.45 239.849 107.789 238.628 108.75 238.084C109.711 237.54 110.932 237.879 111.476 238.84C111.555 238.979 111.634 239.119 111.715 239.258C111.795 239.397 111.876 239.536 111.957 239.674ZM104.102 226.066C105.16 225.749 106.274 226.35 106.591 227.408C106.683 227.713 106.778 228.018 106.875 228.323C107.211 229.375 106.63 230.501 105.578 230.837C104.525 231.173 103.4 230.591 103.064 229.539C102.96 229.212 102.859 228.885 102.76 228.557C102.443 227.499 103.044 226.384 104.102 226.066ZM119.416 249.62C120.173 250.423 120.136 251.689 119.332 252.446C118.529 253.204 117.262 253.167 116.505 252.363C116.27 252.114 116.037 251.862 115.807 251.609C115.063 250.792 115.122 249.527 115.939 248.783C116.756 248.04 118.021 248.1 118.765 248.916C118.98 249.153 119.197 249.388 119.416 249.62ZM102.261 213.316C103.363 213.243 104.315 214.078 104.387 215.18C104.408 215.498 104.432 215.817 104.459 216.136C104.55 217.236 103.732 218.202 102.631 218.294C101.53 218.385 100.564 217.567 100.473 216.466C100.444 216.125 100.419 215.783 100.397 215.442C100.325 214.34 101.159 213.388 102.261 213.316ZM128.903 257.642C129.821 258.256 130.068 259.497 129.455 260.416C128.841 261.334 127.599 261.581 126.681 260.967C126.397 260.777 126.114 260.585 125.832 260.39C124.924 259.76 124.699 258.514 125.328 257.607C125.958 256.699 127.204 256.473 128.111 257.103C128.374 257.285 128.638 257.465 128.903 257.642ZM103.312 200.473C104.402 200.648 105.145 201.673 104.971 202.764C104.92 203.079 104.873 203.395 104.827 203.712C104.671 204.805 103.658 205.565 102.565 205.409C101.471 205.253 100.711 204.24 100.867 203.146C100.915 202.808 100.967 202.47 101.021 202.132C101.195 201.041 102.221 200.298 103.312 200.473ZM139.947 263.345C140.979 263.739 141.496 264.895 141.102 265.927C140.708 266.959 139.552 267.476 138.52 267.082C138.2 266.96 137.882 266.836 137.564 266.708C136.539 266.296 136.042 265.131 136.453 264.106C136.865 263.081 138.03 262.584 139.055 262.995C139.351 263.115 139.649 263.231 139.947 263.345ZM107.181 188.182C108.206 188.594 108.703 189.759 108.291 190.784C108.172 191.08 108.056 191.378 107.942 191.676C107.548 192.708 106.391 193.225 105.36 192.831C104.328 192.436 103.811 191.28 104.205 190.248C104.327 189.929 104.451 189.61 104.579 189.293C104.991 188.268 106.156 187.77 107.181 188.182ZM151.983 266.459C153.076 266.615 153.837 267.629 153.681 268.722C153.525 269.816 152.511 270.576 151.418 270.42C151.079 270.372 150.741 270.32 150.403 270.266C149.312 270.092 148.57 269.066 148.744 267.975C148.919 266.884 149.945 266.142 151.035 266.316C151.351 266.367 151.667 266.414 151.983 266.459ZM113.68 177.057C114.588 177.686 114.814 178.932 114.184 179.84C114.002 180.102 113.822 180.366 113.645 180.632C113.031 181.55 111.789 181.797 110.871 181.183C109.953 180.57 109.706 179.328 110.32 178.41C110.51 178.125 110.702 177.842 110.897 177.561C111.527 176.653 112.773 176.427 113.68 177.057ZM164.407 266.828C165.508 266.737 166.474 267.555 166.565 268.656C166.656 269.757 165.838 270.723 164.737 270.814C164.396 270.843 164.054 270.868 163.713 270.89C162.611 270.962 161.659 270.128 161.587 269.026C161.515 267.924 162.349 266.972 163.451 266.899C163.77 266.879 164.088 266.855 164.407 266.828ZM122.504 167.668C123.247 168.484 123.187 169.75 122.371 170.494C122.134 170.709 121.899 170.926 121.667 171.144C120.863 171.902 119.598 171.865 118.841 171.061C118.083 170.257 118.12 168.991 118.924 168.233C119.173 167.999 119.425 167.766 119.678 167.535C120.495 166.792 121.76 166.851 122.504 167.668ZM176.594 264.412C177.647 264.076 178.773 264.657 179.108 265.709C179.444 266.762 178.862 267.887 177.81 268.223C177.483 268.327 177.156 268.428 176.828 268.526C175.77 268.844 174.655 268.243 174.338 267.185C174.021 266.127 174.621 265.013 175.679 264.695C175.984 264.604 176.29 264.509 176.594 264.412ZM131.277 163.842C130.389 164.163 129.371 163.821 128.875 162.978C128.373 162.126 128.575 161.056 129.305 160.438C129.15 160.941 129.192 161.504 129.468 162C129.554 162.154 129.642 162.308 129.73 162.461C129.819 162.615 129.908 162.767 129.999 162.919C130.291 163.409 130.761 163.725 131.277 163.842ZM190.684 260.038C191.244 260.99 190.927 262.216 189.975 262.777C189.827 262.864 189.678 262.95 189.529 263.036C189.38 263.122 189.231 263.208 189.082 263.292C188.12 263.837 186.899 263.498 186.355 262.537C185.811 261.576 186.15 260.355 187.111 259.811C187.251 259.732 187.39 259.653 187.529 259.572C187.668 259.492 187.807 259.411 187.945 259.33C188.897 258.77 190.123 259.086 190.684 260.038ZM200.718 251.954C201.475 252.758 201.438 254.025 200.634 254.782C200.385 255.017 200.134 255.25 199.88 255.48C199.063 256.224 197.798 256.165 197.055 255.348C196.311 254.531 196.371 253.266 197.188 252.522C197.424 252.307 197.659 252.09 197.891 251.871C198.695 251.114 199.96 251.151 200.718 251.954ZM208.687 241.832C209.605 242.446 209.852 243.688 209.239 244.606C209.049 244.89 208.856 245.173 208.661 245.455C208.031 246.362 206.786 246.588 205.878 245.959C204.97 245.329 204.745 244.083 205.374 243.176C205.556 242.913 205.736 242.649 205.914 242.384C206.527 241.465 207.769 241.219 208.687 241.832ZM214.199 230.185C215.231 230.579 215.747 231.735 215.353 232.767C215.231 233.087 215.107 233.405 214.979 233.723C214.568 234.748 213.403 235.245 212.378 234.834C211.353 234.422 210.855 233.257 211.267 232.232C211.386 231.936 211.503 231.638 211.617 231.34C212.011 230.308 213.167 229.791 214.199 230.185ZM216.994 217.606C218.087 217.762 218.847 218.776 218.691 219.869C218.643 220.208 218.592 220.546 218.537 220.884C218.363 221.974 217.337 222.717 216.246 222.543C215.156 222.368 214.413 221.342 214.588 220.252C214.638 219.936 214.686 219.62 214.731 219.304C214.887 218.211 215.9 217.45 216.994 217.606ZM193.726 162.626C194.634 163.256 194.859 164.501 194.23 165.409C193.601 166.317 192.355 166.542 191.447 165.913C191.184 165.731 190.92 165.551 190.655 165.373C189.737 164.76 189.49 163.518 190.104 162.6C190.717 161.681 191.959 161.435 192.877 162.048C193.162 162.238 193.445 162.431 193.726 162.626ZM216.927 204.722C218.028 204.631 218.994 205.449 219.085 206.55C219.114 206.891 219.139 207.232 219.161 207.574C219.234 208.676 218.399 209.628 217.297 209.7C216.195 209.772 215.243 208.938 215.171 207.836C215.15 207.517 215.126 207.198 215.099 206.88C215.008 205.779 215.827 204.813 216.927 204.722ZM203.752 171.407C204.495 172.224 204.436 173.489 203.619 174.232C202.803 174.976 201.537 174.916 200.793 174.099C200.578 173.863 200.361 173.628 200.143 173.396C199.385 172.592 199.422 171.327 200.226 170.569C201.03 169.812 202.296 169.849 203.054 170.653C203.288 170.902 203.521 171.153 203.752 171.407ZM213.981 192.179C215.033 191.843 216.158 192.425 216.494 193.477C216.598 193.804 216.699 194.131 216.798 194.458C217.115 195.516 216.514 196.632 215.456 196.949C214.398 197.266 213.284 196.666 212.967 195.608C212.875 195.303 212.78 194.997 212.683 194.693C212.347 193.64 212.928 192.514 213.981 192.179ZM211.564 182.205C212.108 183.167 211.769 184.388 210.808 184.932C209.847 185.476 208.627 185.137 208.083 184.176C208.004 184.036 207.924 183.897 207.844 183.758C207.763 183.619 207.682 183.48 207.601 183.342C207.041 182.39 207.358 181.164 208.309 180.603C209.261 180.043 210.488 180.36 211.048 181.312C211.135 181.46 211.222 181.609 211.308 181.758C211.394 181.907 211.479 182.056 211.564 182.205Z";
    const outerTopEndPath =
        "M160.914 100.244C162.005 100.418 162.748 101.444 162.573 102.535C162.523 102.85 162.475 103.166 162.43 103.482C162.274 104.576 161.261 105.336 160.167 105.18C159.074 105.024 158.313 104.011 158.469 102.917C158.518 102.578 158.569 102.24 158.623 101.903C158.798 100.812 159.824 100.069 160.914 100.244ZM197.55 163.116C198.582 163.51 199.098 164.666 198.704 165.698C198.31 166.73 197.154 167.247 196.122 166.853C195.803 166.731 195.484 166.606 195.167 166.479C194.142 166.067 193.644 164.902 194.056 163.877C194.467 162.852 195.633 162.355 196.658 162.766C196.954 162.885 197.251 163.002 197.55 163.116ZM164.783 87.9527C165.808 88.3644 166.306 89.5295 165.894 90.5544C165.775 90.8508 165.658 91.1482 165.544 91.4465C165.15 92.4784 163.994 92.9953 162.962 92.6012C161.93 92.2072 161.413 91.0511 161.807 90.0192C161.929 89.6996 162.054 89.381 162.181 89.0635C162.593 88.0385 163.758 87.5409 164.783 87.9527ZM209.585 166.23C210.679 166.386 211.439 167.4 211.283 168.493C211.127 169.587 210.114 170.347 209.02 170.191C208.682 170.142 208.343 170.091 208.006 170.037C206.915 169.862 206.172 168.837 206.347 167.746C206.522 166.655 207.547 165.912 208.638 166.087C208.953 166.138 209.269 166.185 209.585 166.23ZM171.283 76.8276C172.19 77.457 172.416 78.7029 171.787 79.6106C171.605 79.8731 171.424 80.1372 171.247 80.4025C170.634 81.3209 169.392 81.5676 168.474 80.954C167.555 80.3403 167.308 79.0988 167.922 78.1804C168.112 77.896 168.305 77.613 168.5 77.3315C169.129 76.4239 170.375 76.1981 171.283 76.8276ZM222.009 166.599C223.11 166.508 224.076 167.326 224.168 168.427C224.259 169.527 223.44 170.494 222.34 170.585C221.998 170.613 221.657 170.638 221.316 170.661C220.213 170.733 219.262 169.898 219.189 168.796C219.117 167.694 219.952 166.742 221.054 166.67C221.372 166.649 221.691 166.625 222.009 166.599ZM180.106 67.4382C180.85 68.2551 180.79 69.5208 179.973 70.2643C179.737 70.4795 179.502 70.6963 179.27 70.9151C178.466 71.6724 177.201 71.6353 176.443 70.8319C175.686 70.0281 175.723 68.7616 176.527 68.004C176.776 67.7694 177.027 67.5368 177.281 67.306C178.098 66.5624 179.363 66.6214 180.106 67.4382ZM234.197 164.182C235.249 163.847 236.375 164.428 236.711 165.48C237.046 166.532 236.465 167.658 235.412 167.993C235.086 168.097 234.759 168.199 234.431 168.297C233.373 168.614 232.258 168.014 231.94 166.956C231.623 165.898 232.224 164.784 233.281 164.466C233.587 164.375 233.892 164.28 234.197 164.182ZM190.806 60.2495C191.349 61.2106 191.011 62.431 190.05 62.9751C189.91 63.054 189.771 63.1338 189.632 63.2141C189.493 63.2944 189.354 63.3752 189.216 63.4565C188.264 64.0168 187.038 63.7001 186.477 62.7485C185.917 61.7966 186.234 60.5699 187.186 60.0095C187.334 59.9224 187.483 59.836 187.632 59.75C187.781 59.664 187.93 59.5785 188.079 59.4939C189.04 58.9497 190.261 59.2882 190.806 60.2495ZM248.286 159.809C248.846 160.76 248.529 161.987 247.577 162.548C247.429 162.635 247.281 162.721 247.132 162.807C246.983 162.893 246.834 162.979 246.684 163.063C245.723 163.607 244.502 163.269 243.958 162.308C243.414 161.346 243.753 160.126 244.714 159.582C244.853 159.503 244.993 159.423 245.132 159.343C245.271 159.263 245.409 159.182 245.548 159.101C246.499 158.54 247.726 158.857 248.286 159.809ZM200.332 54.2598C201.39 53.9425 202.506 54.5434 202.823 55.6014C203.14 56.6592 202.54 57.7735 201.482 58.0909C201.176 58.1825 200.871 58.2775 200.567 58.3746C199.514 58.7103 198.388 58.1293 198.053 57.0769C197.717 56.0246 198.298 54.8994 199.351 54.5638C199.677 54.4596 200.005 54.3581 200.332 54.2598ZM258.32 151.725C259.078 152.529 259.04 153.795 258.237 154.553C257.988 154.788 257.736 155.02 257.483 155.251C256.666 155.995 255.401 155.936 254.657 155.119C253.914 154.302 253.973 153.036 254.79 152.293C255.027 152.078 255.262 151.861 255.494 151.642C256.297 150.885 257.563 150.922 258.32 151.725ZM213.448 51.8962C214.55 51.824 215.502 52.6585 215.574 53.7606C215.646 54.8628 214.812 55.8146 213.709 55.8869C213.391 55.9077 213.072 55.9318 212.754 55.9582C211.653 56.0494 210.687 55.231 210.596 54.1303C210.504 53.0295 211.323 52.0635 212.424 51.9722C212.765 51.9438 213.106 51.9186 213.448 51.8962ZM266.29 141.603C267.208 142.217 267.455 143.458 266.841 144.377C266.651 144.661 266.459 144.944 266.263 145.226C265.634 146.133 264.388 146.359 263.48 145.729C262.573 145.1 262.347 143.854 262.976 142.946C263.159 142.684 263.339 142.42 263.516 142.155C264.13 141.236 265.371 140.989 266.29 141.603ZM226.758 52.5201C227.848 52.6948 228.591 53.7205 228.416 54.8112C228.242 55.9019 227.216 56.6446 226.125 56.4699C225.81 56.4194 225.494 56.372 225.178 56.3269C224.084 56.1709 223.324 55.1574 223.48 54.064C223.636 52.9705 224.649 52.2103 225.743 52.3662C226.082 52.4145 226.42 52.4661 226.758 52.5201ZM271.801 129.956C272.833 130.35 273.35 131.506 272.956 132.538C272.834 132.857 272.709 133.176 272.582 133.494C272.17 134.519 271.005 135.016 269.98 134.604C268.955 134.193 268.458 133.028 268.869 132.003C268.988 131.706 269.105 131.409 269.219 131.111C269.613 130.079 270.769 129.562 271.801 129.956ZM239.597 56.0783C240.622 56.49 241.119 57.6551 240.707 58.6801C240.296 59.705 239.131 60.2025 238.106 59.7909C237.809 59.6718 237.512 59.555 237.214 59.441C236.182 59.047 235.665 57.8909 236.059 56.859C236.453 55.8271 237.609 55.3102 238.641 55.7043C238.961 55.8263 239.279 55.9508 239.597 56.0783ZM274.596 117.377C275.69 117.533 276.45 118.546 276.294 119.64C276.246 119.979 276.194 120.317 276.14 120.655C275.965 121.745 274.94 122.488 273.849 122.313C272.758 122.139 272.016 121.113 272.19 120.022C272.241 119.707 272.288 119.391 272.333 119.075C272.489 117.981 273.503 117.221 274.596 117.377ZM251.329 62.3967C252.236 63.0262 252.462 64.2721 251.833 65.1797C251.203 66.0873 249.957 66.313 249.05 65.6837C248.787 65.5016 248.523 65.3213 248.258 65.144C247.339 64.5304 247.093 63.2889 247.706 62.3705C248.32 61.4521 249.561 61.2054 250.48 61.819C250.764 62.009 251.047 62.2015 251.329 62.3967ZM274.53 104.493C275.631 104.401 276.597 105.22 276.688 106.32C276.716 106.662 276.742 107.003 276.764 107.345C276.836 108.447 276.002 109.398 274.9 109.471C273.797 109.543 272.846 108.709 272.773 107.606C272.752 107.288 272.728 106.969 272.702 106.651C272.611 105.55 273.429 104.584 274.53 104.493ZM261.354 71.1775C262.098 71.9944 262.039 73.2596 261.222 74.0031C260.405 74.7466 259.139 74.6868 258.396 73.87C258.181 73.6335 257.964 73.3987 257.745 73.1666C256.988 72.3629 257.025 71.0976 257.828 70.34C258.632 69.5824 259.899 69.6198 260.656 70.4236C260.891 70.6725 261.123 70.924 261.354 71.1775ZM271.583 91.9494C272.636 91.6138 273.761 92.1953 274.096 93.2477C274.201 93.5743 274.302 93.9015 274.4 94.2291C274.718 95.2872 274.117 96.4027 273.059 96.72C272.001 97.0369 270.887 96.4365 270.569 95.3788C270.478 95.0732 270.383 94.7681 270.286 94.4634C269.95 93.4111 270.531 92.2851 271.583 91.9494ZM269.166 81.976C269.71 82.9373 269.372 84.1584 268.411 84.7025C267.45 85.2463 266.229 84.9076 265.685 83.9464C265.606 83.8069 265.526 83.6676 265.446 83.5285C265.366 83.3894 265.285 83.2507 265.204 83.1125C264.643 82.1608 264.96 80.9345 265.912 80.3741C266.864 79.8137 268.09 80.1311 268.651 81.0829C268.738 81.2309 268.824 81.3795 268.91 81.5285C268.996 81.6775 269.082 81.8266 269.166 81.976Z";

    const outerLeftMorph = createPathMorph(outerLeftStartPath, outerLeftEndPath);
    const outerRightMorph = createPathMorph(outerRightStartPath, outerRightEndPath);
    const outerTopMorph = createPathMorph(outerTopStartPath, outerTopEndPath);

    const lines = [
        { node: l1, start: [170, 149, 149, 149], end: [185.826, 141.621, 175.326, 123.435] },
        { node: l2, start: [170, 198, 149, 198], end: [143.39, 166.121, 132.89, 147.935] },
        { node: l3, start: [178, 155, 139, 155], end: [184.629, 151.549, 165.129, 117.774] },
        { node: l4, start: [178, 188, 139, 188], end: [156.051, 168.049, 136.551, 134.274] },
        { node: l5, start: [173, 193, 145, 193], end: [149.22, 166.219, 135.22, 141.97] },
        { node: l6, start: [183, 162, 135, 162], end: [181.067, 159.379, 157.067, 117.81] },
        { node: l7, start: [183, 182, 135, 182], end: [163.746, 169.379, 139.746, 127.81] },
        { node: l8, start: [185, 169, 133, 169], end: [176.005, 164.612, 150.005, 119.578] },
        { node: l9, start: [185, 176, 133, 176], end: [169.943, 168.112, 143.943, 123.078] },
    ];

    return {
        node: svg,
        speed: 0.055,
        touchSpeed: 0.045,
        apply(progress) {
            const t = clamp(progress, 0, 1);
            const smooth = t * t * (3 - 2 * t);
            const flow = smooth * smooth * (3 - 2 * smooth);
            const color = mixColor(INK, PINK, flow);
            const opacity = mix(0.5, 1, flow);

            layer.setAttribute("opacity", String(opacity));

            [core, ...lines.map((item) => item.node)].forEach((shape) => {
                shape.setAttribute("stroke", color);
                shape.setAttribute("stroke-width", "4");
                shape.setAttribute("stroke-linecap", "round");
                shape.setAttribute("stroke-linejoin", "round");
                shape.setAttribute("stroke-dasharray", "1 12");
                shape.setAttribute("stroke-opacity", String(opacity));
            });

            [outerLeft, outerRight, outerTop].forEach((shape) => {
                shape.setAttribute("fill", color);
                shape.setAttribute("fill-opacity", String(opacity));
                shape.setAttribute("stroke", "none");
            });

            outerLeft.setAttribute("d", outerLeftMorph(flow));
            outerRight.setAttribute("d", outerRightMorph(flow));
            outerTop.setAttribute("d", outerTopMorph(flow));

            core.setAttribute("d", coreMorph(flow));

            lines.forEach((item) => {
                item.node.setAttribute("x1", String(mix(item.start[0], item.end[0], flow)));
                item.node.setAttribute("y1", String(mix(item.start[1], item.end[1], flow)));
                item.node.setAttribute("x2", String(mix(item.start[2], item.end[2], flow)));
                item.node.setAttribute("y2", String(mix(item.start[3], item.end[3], flow)));
            });
        },
    };
}

export { renderCurtain, renderTripleCircles, renderTriangleMorph, renderDiamondSquare, renderGearsPanel, renderGearsPanelRight, renderCircleRails, renderOrbitQuads, renderFrameRailsUp, renderFrameRailsSpread, renderDiamondHatch, renderShelfAnalysis, renderPackageAnalysis, renderRetailAuditInPieteleTinta, renderStrategiaDeExport, renderWebsiteAnalysis, renderBannerAnalysis, renderVideoSpotAnalysis, renderConfusionAnalysis, renderMarketingStrategyElaboration, renderCommunicationMessageTesting, renderCampaignImpactEvaluation, renderCommunicationCampaignImpactEvaluation, renderPublicProgramImpactEvaluation, renderBlindTasting, renderExportMarketVolumeEstimation, renderTargetMarketIdentification, renderExportMarketResearch, renderTargetMarketPartnerIdentification };
